export const DictionaryIllustrator_en_US = [
    {
        id: 18,
        label: 'Edit > Paste in Front',
        placement: 'MenuBar',
        name: 'Paste in Front',
    },
    {
        id: 19,
        label: 'Edit > Paste in Back',
        placement: 'MenuBar',
        name: 'Paste in Back',
    },
    {
        id: 20,
        label: 'File > New from Template...',
        placement: 'MenuBar',
        name: 'New from Template...',
    },
    {
        id: 22,
        label: 'Object > Transform > Transform Again',
        placement: 'MenuBar',
        name: 'Transform Again',
    },
    {
        id: 23,
        label: 'Object > Group',
        placement: 'MenuBar',
        name: 'Group',
    },
    {
        id: 24,
        label: 'Object > Ungroup',
        placement: 'MenuBar',
        name: 'Ungroup',
    },
    {
        id: 25,
        label: 'Object > Path > Join',
        placement: 'MenuBar',
        name: 'Join',
    },
    {
        id: 26,
        label: 'Object > Path > Average...',
        placement: 'MenuBar',
        name: 'Average...',
    },
    {
        id: 28,
        label: 'Object > Lock > Selection',
        placement: 'MenuBar',
        name: 'Selection',
    },
    {
        id: 29,
        label: 'Object > Unlock All',
        placement: 'MenuBar',
        name: 'Unlock All',
    },
    {
        id: 30,
        label: 'View > Preview',
        placement: 'MenuBar',
        name: 'Preview',
    },
    {
        id: 33,
        label: 'View > Pixel Preview',
        placement: 'MenuBar',
        name: 'Pixel Preview',
    },
    {
        id: 34,
        label: 'Type > Area Type Options...',
        placement: 'MenuBar',
        name: 'Area Type Options...',
    },
    {
        id: 35,
        label: 'View > Fit Artboard in Window',
        placement: 'MenuBar',
        name: 'Fit Artboard in Window',
    },
    {
        id: 36,
        label: 'Window > New Window',
        placement: 'MenuBar',
        name: 'New Window',
    },
    {
        id: 37,
        label: 'View > Rulers > Show Rulers',
        placement: 'MenuBar',
        name: 'Show Rulers',
    },
    {
        id: 38,
        label: 'Type > Type on a Path > 3D Ribbon',
        placement: 'MenuBar',
        name: '3D Ribbon',
    },
    {
        id: 40,
        label: 'Type > Type on a Path > Stair Step',
        placement: 'MenuBar',
        name: 'Stair Step',
    },
    {
        id: 42,
        label: 'Object > Arrange > Bring to Front',
        placement: 'MenuBar',
        name: 'Bring to Front',
    },
    {
        id: 43,
        label: 'Object > Arrange > Send to Back',
        placement: 'MenuBar',
        name: 'Send to Back',
    },
    {
        id: 48,
        label: 'File > Save as Template...',
        placement: 'MenuBar',
        name: 'Save as Template...',
    },
    {
        id: 50,
        label: 'Object > Hide > Selection',
        placement: 'MenuBar',
        name: 'Selection',
    },
    {
        id: 51,
        label: 'Object > Show All',
        placement: 'MenuBar',
        name: 'Show All',
    },
    {
        id: 52,
        label: 'View > Guides > Make Guides',
        placement: 'MenuBar',
        name: 'Make Guides',
    },
    {
        id: 53,
        label: 'View > Guides > Release Guides',
        placement: 'MenuBar',
        name: 'Release Guides',
    },
    {
        id: 54,
        label: 'Object > Transform > Move...',
        placement: 'MenuBar',
        name: 'Move...',
    },
    {
        id: 55,
        label: 'Illustrator > Settings… > Smart Guides...',
        placement: 'MenuBar',
        name: 'Smart Guides...',
    },
    {
        id: 56,
        label: 'Object > Compound Path > Make',
        placement: 'MenuBar',
        name: 'Make',
    },
    {
        id: 57,
        label: 'Object > Compound Path > Release',
        placement: 'MenuBar',
        name: 'Release',
    },
    {
        id: 62,
        label: 'Type > Create Outlines',
        placement: 'MenuBar',
        name: 'Create Outlines',
    },
    {
        id: 63,
        label: 'View > Actual Size',
        placement: 'MenuBar',
        name: 'Actual Size',
    },
    {
        id: 74,
        label: 'Object > Graph > Type...',
        placement: 'MenuBar',
        name: 'Type...',
    },
    {
        id: 75,
        label: 'Object > Graph > Data...',
        placement: 'MenuBar',
        name: 'Data...',
    },
    {
        id: 76,
        label: 'Object > Graph > Column...',
        placement: 'MenuBar',
        name: 'Column...',
    },
    {
        id: 77,
        label: 'Object > Graph > Design...',
        placement: 'MenuBar',
        name: 'Design...',
    },
    {
        id: 78,
        label: 'Object > Graph > Marker...',
        placement: 'MenuBar',
        name: 'Marker...',
    },
    {
        id: 83,
        label: 'Type > Type on a Path > Rainbow',
        placement: 'MenuBar',
        name: 'Rainbow',
    },
    {
        id: 84,
        label: 'File > Document Setup...',
        placement: 'MenuBar',
        name: 'Document Setup...',
    },
    {
        id: 85,
        label: 'View > Hide Print Tiling',
        placement: 'MenuBar',
        name: 'Hide Print Tiling',
    },
    {
        id: 86,
        label: 'View > Hide Artboards',
        placement: 'MenuBar',
        name: 'Hide Artboards',
    },
    {
        id: 87,
        label: 'Type > Fit Headline',
        placement: 'MenuBar',
        name: 'Fit Headline',
    },
    {
        id: 95,
        label: 'File > Save a Copy...',
        placement: 'MenuBar',
        name: 'Save a Copy...',
    },
    {
        id: 98,
        label: 'Illustrator > Settings… > Type...',
        placement: 'MenuBar',
        name: 'Type...',
    },
    {
        id: 99,
        label: 'Illustrator > Settings… > Units...',
        placement: 'MenuBar',
        name: 'Units...',
    },
    {
        id: 100,
        label: 'Object > Arrange > Bring Forward',
        placement: 'MenuBar',
        name: 'Bring Forward',
    },
    {
        id: 101,
        label: 'Object > Arrange > Send Backward',
        placement: 'MenuBar',
        name: 'Send Backward',
    },
    {
        id: 109,
        label: 'Window > Arrange > Minimize Window',
        placement: 'MenuBar',
        name: 'Minimize Window',
    },
    {
        id: 110,
        label: 'Window > Arrange > Bring All to Front',
        placement: 'MenuBar',
        name: 'Bring All to Front',
    },
    {
        id: 113,
        label: 'View > Guides > Clear Guides',
        placement: 'MenuBar',
        name: 'Clear Guides',
    },
    {
        id: 114,
        label: 'View > Show Template',
        placement: 'MenuBar',
        name: 'Show Template',
    },
    {
        id: 115,
        label: 'Type > Show Hidden Characters',
        placement: 'MenuBar',
        name: 'Show Hidden Characters',
    },
    {
        id: 116,
        label: 'Type > Type on a Path > Skew',
        placement: 'MenuBar',
        name: 'Skew',
    },
    {
        id: 117,
        label: 'File > Close All',
        placement: 'MenuBar',
        name: 'Close All',
    },
    {
        id: 119,
        label: 'Type > Type on a Path > Gravity',
        placement: 'MenuBar',
        name: 'Gravity',
    },
    {
        id: 120,
        label: 'Object > Clipping Mask > Make',
        placement: 'MenuBar',
        name: 'Make',
    },
    {
        id: 121,
        label: 'Object > Clipping Mask > Release',
        placement: 'MenuBar',
        name: 'Release',
    },
    {
        id: 123,
        label: 'Type > Type on a Path > Type on a Path Options...',
        placement: 'MenuBar',
        name: 'Type on a Path Options...',
    },
    {
        id: 127,
        label: 'Object > Artboards > Convert to Artboards',
        placement: 'MenuBar',
        name: 'Convert to Artboards',
    },
    {
        id: 133,
        label: 'Type > Threaded Text > Create',
        placement: 'MenuBar',
        name: 'Create',
    },
    {
        id: 135,
        label: 'View > Zoom In',
        placement: 'MenuBar',
        name: 'Zoom In',
    },
    {
        id: 136,
        label: 'View > Zoom Out',
        placement: 'MenuBar',
        name: 'Zoom Out',
    },
    {
        id: 139,
        label: 'Edit > Color Settings...',
        placement: 'MenuBar',
        name: 'Color Settings...',
    },
    {
        id: 140,
        label: 'Illustrator > Settings… > Hyphenation...',
        placement: 'MenuBar',
        name: 'Hyphenation...',
    },
    {
        id: 141,
        label: 'Illustrator > Settings… > Plug-ins & Scratch Disks...',
        placement: 'MenuBar',
        name: 'Plug-ins & Scratch Disks...',
    },
    {
        id: 142,
        label: 'Select > Deselect',
        placement: 'MenuBar',
        name: 'Deselect',
    },
    {
        id: 143,
        label: 'View > Overprint Preview',
        placement: 'MenuBar',
        name: 'Overprint Preview',
    },
    {
        id: 144,
        label: 'View > New View...',
        placement: 'MenuBar',
        name: 'New View...',
    },
    {
        id: 145,
        label: 'View > Edit Views...',
        placement: 'MenuBar',
        name: 'Edit Views...',
    },
    {
        id: 146,
        label: 'View > Snap to Point',
        placement: 'MenuBar',
        name: 'Snap to Point',
    },
    {
        id: 147,
        label: 'View > Hide Edges',
        placement: 'MenuBar',
        name: 'Hide Edges',
    },
    {
        id: 148,
        label: 'Object > Expand Appearance',
        placement: 'MenuBar',
        name: 'Expand Appearance',
    },
    {
        id: 150,
        label: 'View > Show Text Threads',
        placement: 'MenuBar',
        name: 'Show Text Threads',
    },
    {
        id: 154,
        label: 'View > Guides > Hide Guides',
        placement: 'MenuBar',
        name: 'Hide Guides',
    },
    {
        id: 155,
        label: 'View > Guides > Lock Guides',
        placement: 'MenuBar',
        name: 'Lock Guides',
    },
    {
        id: 157,
        label: 'Type > Threaded Text > Release Selection',
        placement: 'MenuBar',
        name: 'Release Selection',
    },
    {
        id: 158,
        label: 'Type > Threaded Text > Remove Threading',
        placement: 'MenuBar',
        name: 'Remove Threading',
    },
    {
        id: 159,
        label: 'View > Show Grid',
        placement: 'MenuBar',
        name: 'Show Grid',
    },
    {
        id: 160,
        label: 'View > Snap to Grid',
        placement: 'MenuBar',
        name: 'Snap to Grid',
    },
    {
        id: 161,
        label: 'Illustrator > Settings… > Guides & Grid...',
        placement: 'MenuBar',
        name: 'Guides & Grid...',
    },
    {
        id: 162,
        label: 'Object > Transform > Rotate...',
        placement: 'MenuBar',
        name: 'Rotate...',
    },
    {
        id: 163,
        label: 'Object > Transform > Scale...',
        placement: 'MenuBar',
        name: 'Scale...',
    },
    {
        id: 164,
        label: 'Object > Transform > Reflect...',
        placement: 'MenuBar',
        name: 'Reflect...',
    },
    {
        id: 165,
        label: 'Object > Transform > Shear...',
        placement: 'MenuBar',
        name: 'Shear...',
    },
    {
        id: 166,
        label: 'Window > Arrange > Cascade',
        placement: 'MenuBar',
        name: 'Cascade',
    },
    {
        id: 168,
        label: 'Window > Arrange > Tile',
        placement: 'MenuBar',
        name: 'Tile',
    },
    {
        id: 202,
        label: 'View > Proof Colors',
        placement: 'MenuBar',
        name: 'Proof Colors',
    },
    {
        id: 203,
        label: 'Edit > Assign Profile...',
        placement: 'MenuBar',
        name: 'Assign Profile...',
    },
    {
        id: 204,
        label: 'Help > Tutorials...',
        placement: 'MenuBar',
        name: 'Tutorials...',
    },
    {
        id: 223,
        label: 'File > Document Color Mode > CMYK Color',
        placement: 'MenuBar',
        name: 'CMYK Color',
    },
    {
        id: 224,
        label: 'File > Document Color Mode > RGB Color',
        placement: 'MenuBar',
        name: 'RGB Color',
    },
    {
        id: 225,
        label: 'View > Proof Setup > Document CMYK:',
        placement: 'MenuBar',
        name: 'Document CMYK:',
    },
    {
        id: 226,
        label: 'View > Proof Setup > Legacy Macintosh RGB (Gamma 1.8)',
        placement: 'MenuBar',
        name: 'Legacy Macintosh RGB (Gamma 1.8)',
    },
    {
        id: 227,
        label: 'View > Proof Setup > Internet Standard RGB (sRGB)',
        placement: 'MenuBar',
        name: 'Internet Standard RGB (sRGB)',
    },
    {
        id: 228,
        label: 'View > Proof Setup > Monitor RGB',
        placement: 'MenuBar',
        name: 'Monitor RGB',
    },
    {
        id: 229,
        label: 'Type > Type Orientation > Horizontal',
        placement: 'MenuBar',
        name: 'Horizontal',
    },
    {
        id: 230,
        label: 'Type > Type Orientation > Vertical',
        placement: 'MenuBar',
        name: 'Vertical',
    },
    {
        id: 232,
        label: 'Help > System Info...',
        placement: 'MenuBar',
        name: 'System Info...',
    },
    {
        id: 278,
        label: 'Type > Legacy Text > Update All Legacy Text',
        placement: 'MenuBar',
        name: 'Update All Legacy Text',
    },
    {
        id: 279,
        label: 'Type > Legacy Text > Update Selected Legacy Text',
        placement: 'MenuBar',
        name: 'Update Selected Legacy Text',
    },
    {
        id: 280,
        label: 'Type > Legacy Text > Hide Copies',
        placement: 'MenuBar',
        name: 'Hide Copies',
    },
    {
        id: 281,
        label: 'Type > Legacy Text > Delete Copies',
        placement: 'MenuBar',
        name: 'Delete Copies',
    },
    {
        id: 282,
        label: 'Type > Legacy Text > Select Copies',
        placement: 'MenuBar',
        name: 'Select Copies',
    },
    {
        id: 284,
        label: 'View > Proof Setup > Customize...',
        placement: 'MenuBar',
        name: 'Customize...',
    },
    {
        id: 289,
        label: 'Illustrator > Settings… > Selection & Anchor Display...',
        placement: 'MenuBar',
        name: 'Selection & Anchor Display...',
    },
    {
        id: 292,
        label: 'Object > Clipping Mask > Edit Contents',
        placement: 'MenuBar',
        name: 'Edit Contents',
    },
    {
        id: 293,
        label: 'Illustrator > Settings… > User Interface...',
        placement: 'MenuBar',
        name: 'User Interface...',
    },
    {
        id: 294,
        label: 'Illustrator > Settings… > Slices...',
        placement: 'MenuBar',
        name: 'Slices...',
    },
    {
        id: 295,
        label: 'Window > Application Frame',
        placement: 'MenuBar',
        name: 'Application Frame',
    },
    {
        id: 296,
        label: 'View > Proof Setup > Color blindness - Protanopia-type',
        placement: 'MenuBar',
        name: 'Color blindness - Protanopia-type',
    },
    {
        id: 297,
        label: 'View > Proof Setup > Color blindness - Deuteranopia-type',
        placement: 'MenuBar',
        name: 'Color blindness - Deuteranopia-type',
    },
    {
        id: 299,
        label: 'View > Rulers > Show Video Rulers',
        placement: 'MenuBar',
        name: 'Show Video Rulers',
    },
    {
        id: 301,
        label: 'Window > Arrange > Float in Window',
        placement: 'MenuBar',
        name: 'Float in Window',
    },
    {
        id: 302,
        label: 'Window > Arrange > Float All in Windows',
        placement: 'MenuBar',
        name: 'Float All in Windows',
    },
    {
        id: 303,
        label: 'Window > Arrange > Consolidate All Windows',
        placement: 'MenuBar',
        name: 'Consolidate All Windows',
    },
    {
        id: 304,
        label: 'Window > Application Bar',
        placement: 'MenuBar',
        name: 'Application Bar',
    },
    {
        id: 310,
        label: 'Type > Type on a Path > Update Legacy Type on a Path',
        placement: 'MenuBar',
        name: 'Update Legacy Type on a Path',
    },
    {
        id: 311,
        label: 'View > Fit All in Window',
        placement: 'MenuBar',
        name: 'Fit All in Window',
    },
    {
        id: 315,
        label: 'Edit > Paste in Place',
        placement: 'MenuBar',
        name: 'Paste in Place',
    },
    {
        id: 316,
        label: 'Edit > Paste on All Artboards',
        placement: 'MenuBar',
        name: 'Paste on All Artboards',
    },
    {
        id: 331,
        label: 'Type > Text Type Conversion',
        placement: 'MenuBar',
        name: 'Text Type Conversion',
    },
    {
        id: 339,
        label: 'Edit > My Settings > Export Settings...',
        placement: 'MenuBar',
        name: 'Export Settings...',
    },
    {
        id: 340,
        label: 'Edit > My Settings > Import Settings...',
        placement: 'MenuBar',
        name: 'Import Settings...',
    },
    {
        id: 347,
        label: 'View > View using GPU',
        placement: 'MenuBar',
        name: 'View using GPU',
    },
    {
        id: 351,
        label: 'File > Export Selection...',
        placement: 'MenuBar',
        name: 'Export Selection...',
    },
    {
        id: 353,
        label: 'View > Snap to Pixel',
        placement: 'MenuBar',
        name: 'Snap to Pixel',
    },
    {
        id: 354,
        label: 'File > Export > Export for Screens...',
        placement: 'MenuBar',
        name: 'Export for Screens...',
    },
    {
        id: 355,
        label: 'File > Export > Export As...',
        placement: 'MenuBar',
        name: 'Export As...',
    },
    {
        id: 356,
        label: 'File > Export > Save for Web (Legacy)...',
        placement: 'MenuBar',
        name: 'Save for Web (Legacy)...',
    },
    {
        id: 368,
        label: 'Type > Insert Special Character > Symbols > Bullet',
        placement: 'MenuBar',
        name: 'Bullet',
    },
    {
        id: 369,
        label: 'Type > Insert Special Character > Symbols > Copyright Symbol',
        placement: 'MenuBar',
        name: 'Copyright Symbol',
    },
    {
        id: 370,
        label: 'Type > Insert Special Character > Symbols > Ellipsis',
        placement: 'MenuBar',
        name: 'Ellipsis',
    },
    {
        id: 371,
        label: 'Type > Insert Special Character > Symbols > Paragraph Symbol',
        placement: 'MenuBar',
        name: 'Paragraph Symbol',
    },
    {
        id: 372,
        label: 'Type > Insert Special Character > Symbols > Registered Trademark Symbol',
        placement: 'MenuBar',
        name: 'Registered Trademark Symbol',
    },
    {
        id: 373,
        label: 'Type > Insert Special Character > Symbols > Section Symbol',
        placement: 'MenuBar',
        name: 'Section Symbol',
    },
    {
        id: 374,
        label: 'Type > Insert Special Character > Symbols > Trademark Symbol',
        placement: 'MenuBar',
        name: 'Trademark Symbol',
    },
    {
        id: 375,
        label: 'Type > Insert Special Character > Quotation Marks > Double Left Quotation Marks',
        placement: 'MenuBar',
        name: 'Double Left Quotation Marks',
    },
    {
        id: 376,
        label: 'Type > Insert Special Character > Quotation Marks > Double Right Quotation Marks',
        placement: 'MenuBar',
        name: 'Double Right Quotation Marks',
    },
    {
        id: 377,
        label: 'Type > Insert Special Character > Quotation Marks > Single Left Quotation Marks',
        placement: 'MenuBar',
        name: 'Single Left Quotation Marks',
    },
    {
        id: 378,
        label: 'Type > Insert Special Character > Quotation Marks > Single Right Quotation Marks',
        placement: 'MenuBar',
        name: 'Single Right Quotation Marks',
    },
    {
        id: 379,
        label: 'Type > Insert Special Character > Hyphens And Dashes > Em Dash',
        placement: 'MenuBar',
        name: 'Em Dash',
    },
    {
        id: 380,
        label: 'Type > Insert Special Character > Hyphens And Dashes > En Dash',
        placement: 'MenuBar',
        name: 'En Dash',
    },
    {
        id: 381,
        label: 'Type > Insert Special Character > Hyphens And Dashes > Discretionary Hyphen',
        placement: 'MenuBar',
        name: 'Discretionary Hyphen',
    },
    {
        id: 382,
        label: 'Type > Insert WhiteSpace Character > Em Space',
        placement: 'MenuBar',
        name: 'Em Space',
    },
    {
        id: 383,
        label: 'Type > Insert WhiteSpace Character > En Space',
        placement: 'MenuBar',
        name: 'En Space',
    },
    {
        id: 384,
        label: 'Type > Insert WhiteSpace Character > Hair Space',
        placement: 'MenuBar',
        name: 'Hair Space',
    },
    {
        id: 385,
        label: 'Type > Insert WhiteSpace Character > Thin Space',
        placement: 'MenuBar',
        name: 'Thin Space',
    },
    {
        id: 386,
        label: 'Type > Insert Break Character > Forced Line Break',
        placement: 'MenuBar',
        name: 'Forced Line Break',
    },
    {
        id: 391,
        label: 'Type > Fill With PlaceHolder Text',
        placement: 'MenuBar',
        name: 'Fill With PlaceHolder Text',
    },
    {
        id: 393,
        label: 'Object > Collect For Export > As Single Asset',
        placement: 'MenuBar',
        name: 'As Single Asset',
    },
    {
        id: 394,
        label: 'Object > Collect For Export > As Multiple Assets',
        placement: 'MenuBar',
        name: 'As Multiple Assets',
    },
    {
        id: 396,
        label: 'View > Trim View',
        placement: 'MenuBar',
        name: 'Trim View',
    },
    {
        id: 397,
        label: 'View > Presentation Mode',
        placement: 'MenuBar',
        name: 'Presentation Mode',
    },
    {
        id: 404,
        label: 'View > Screen Mode > Normal Screen Mode',
        placement: 'MenuBar',
        name: 'Normal Screen Mode',
    },
    {
        id: 405,
        label: 'View > Screen Mode > Full Screen with Menu Bar Mode',
        placement: 'MenuBar',
        name: 'Full Screen with Menu Bar Mode',
    },
    {
        id: 406,
        label: 'View > Screen Mode > Full Screen Mode',
        placement: 'MenuBar',
        name: 'Full Screen Mode',
    },
    {
        id: 411,
        label: 'View > Snap to Glyph',
        placement: 'MenuBar',
        name: 'Snap to Glyph',
    },
    {
        id: 415,
        label: 'View > Rotate View To Selection',
        placement: 'MenuBar',
        name: 'Rotate View To Selection',
    },
    {
        id: 417,
        label: 'View > Rotate View > 180',
        placement: 'MenuBar',
        name: '180',
    },
    {
        id: 418,
        label: 'View > Rotate View > 150',
        placement: 'MenuBar',
        name: '150',
    },
    {
        id: 419,
        label: 'View > Rotate View > 135',
        placement: 'MenuBar',
        name: '135',
    },
    {
        id: 420,
        label: 'View > Rotate View > 120',
        placement: 'MenuBar',
        name: '120',
    },
    {
        id: 421,
        label: 'View > Rotate View > 90',
        placement: 'MenuBar',
        name: '90',
    },
    {
        id: 422,
        label: 'View > Rotate View > 60',
        placement: 'MenuBar',
        name: '60',
    },
    {
        id: 423,
        label: 'View > Rotate View > 45',
        placement: 'MenuBar',
        name: '45',
    },
    {
        id: 424,
        label: 'View > Rotate View > 30',
        placement: 'MenuBar',
        name: '30',
    },
    {
        id: 425,
        label: 'View > Rotate View > 15',
        placement: 'MenuBar',
        name: '15',
    },
    {
        id: 426,
        label: 'View > Rotate View > 0',
        placement: 'MenuBar',
        name: '0',
    },
    {
        id: 427,
        label: 'View > Rotate View > -15',
        placement: 'MenuBar',
        name: '-15',
    },
    {
        id: 428,
        label: 'View > Rotate View > -30',
        placement: 'MenuBar',
        name: '-30',
    },
    {
        id: 429,
        label: 'View > Rotate View > -45',
        placement: 'MenuBar',
        name: '-45',
    },
    {
        id: 430,
        label: 'View > Rotate View > -60',
        placement: 'MenuBar',
        name: '-60',
    },
    {
        id: 431,
        label: 'View > Rotate View > -90',
        placement: 'MenuBar',
        name: '-90',
    },
    {
        id: 432,
        label: 'View > Rotate View > -120',
        placement: 'MenuBar',
        name: '-120',
    },
    {
        id: 433,
        label: 'View > Rotate View > -135',
        placement: 'MenuBar',
        name: '-135',
    },
    {
        id: 434,
        label: 'View > Rotate View > -150',
        placement: 'MenuBar',
        name: '-150',
    },
    {
        id: 435,
        label: 'View > Rotate View > -180',
        placement: 'MenuBar',
        name: '-180',
    },
    {
        id: 436,
        label: 'View > Reset Rotate View',
        placement: 'MenuBar',
        name: 'Reset Rotate View',
    },
    {
        id: 437,
        label: 'Edit > Paste without Formatting',
        placement: 'MenuBar',
        name: 'Paste without Formatting',
    },
    {
        id: 438,
        label: "Help > What's New...",
        placement: 'MenuBar',
        name: "What's New...",
    },
    {
        id: 440,
        label: 'Type > Bullets and Numbering > Apply Bullets',
        placement: 'MenuBar',
        name: 'Apply Bullets',
    },
    {
        id: 441,
        label: 'Type > Bullets and Numbering > Apply Numbers',
        placement: 'MenuBar',
        name: 'Apply Numbers',
    },
    {
        id: 448,
        label: 'Type > Bullets and Numbering > Convert to text',
        placement: 'MenuBar',
        name: 'Convert to text',
    },
    {
        id: 456,
        label: 'Type > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 471,
        label: 'Object > Ungroup All',
        placement: 'MenuBar',
        name: 'Ungroup All',
    },
    {
        id: 472,
        label: 'Type > Insert WhiteSpace Character > Nonbreaking Space',
        placement: 'MenuBar',
        name: 'Nonbreaking Space',
    },
    {
        id: 1383427079,
        label: 'View > Rulers > Change to Artboard Rulers',
        placement: 'MenuBar',
        name: 'Change to Artboard Rulers',
    },
    {
        id: 1633841013,
        label: 'Illustrator > About Illustrator...',
        placement: 'MenuBar',
        name: 'About Illustrator...',
    },
    {
        id: 1634233456,
        label: 'Help > Illustrator Help...',
        placement: 'MenuBar',
        name: 'Illustrator Help...',
    },
    {
        id: 1634296684,
        label: 'File > Close',
        placement: 'MenuBar',
        name: 'Close',
    },
    {
        id: 1668048225,
        label: 'Edit > Clear',
        placement: 'MenuBar',
        name: 'Clear',
    },
    {
        id: 1668247673,
        label: 'Edit > Copy',
        placement: 'MenuBar',
        name: 'Copy',
    },
    {
        id: 1668641824,
        label: 'Edit > Cut',
        placement: 'MenuBar',
        name: 'Cut',
    },
    {
        id: 1751737445,
        label: 'Illustrator > Hide Illustrator',
        placement: 'MenuBar',
        name: 'Hide Illustrator',
    },
    {
        id: 1751737455,
        label: 'Illustrator > Hide Others',
        placement: 'MenuBar',
        name: 'Hide Others',
    },
    {
        id: 1852143392,
        label: 'File > New...',
        placement: 'MenuBar',
        name: 'New...',
    },
    {
        id: 1869636974,
        label: 'File > Open...',
        placement: 'MenuBar',
        name: 'Open...',
    },
    {
        id: 1885434740,
        label: 'Edit > Paste',
        placement: 'MenuBar',
        name: 'Paste',
    },
    {
        id: 1886545254,
        label: 'Illustrator > Settings… > General...',
        placement: 'MenuBar',
        name: 'General...',
    },
    {
        id: 1903520116,
        label: 'Illustrator > Quit Illustrator',
        placement: 'MenuBar',
        name: 'Quit Illustrator',
    },
    {
        id: 1919247471,
        label: 'Edit > Redo',
        placement: 'MenuBar',
        name: 'Redo',
    },
    {
        id: 1920365172,
        label: 'File > Revert',
        placement: 'MenuBar',
        name: 'Revert',
    },
    {
        id: 1934727834,
        label: 'Select > All on Active Artboard',
        placement: 'MenuBar',
        name: 'All on Active Artboard',
    },
    {
        id: 1935764588,
        label: 'Select > All',
        placement: 'MenuBar',
        name: 'All',
    },
    {
        id: 1935767141,
        label: 'File > Save',
        placement: 'MenuBar',
        name: 'Save',
    },
    {
        id: 1936220524,
        label: 'Illustrator > Show All',
        placement: 'MenuBar',
        name: 'Show All',
    },
    {
        id: 1936292352,
        label: 'Type > Size > 6 pt',
        placement: 'MenuBar',
        name: '6 pt',
    },
    {
        id: 1936292353,
        label: 'Type > Size > 7 pt',
        placement: 'MenuBar',
        name: '7 pt',
    },
    {
        id: 1936292354,
        label: 'Type > Size > 8 pt',
        placement: 'MenuBar',
        name: '8 pt',
    },
    {
        id: 1936292355,
        label: 'Type > Size > 9 pt',
        placement: 'MenuBar',
        name: '9 pt',
    },
    {
        id: 1936292356,
        label: 'Type > Size > 10 pt',
        placement: 'MenuBar',
        name: '10 pt',
    },
    {
        id: 1936292357,
        label: 'Type > Size > 11 pt',
        placement: 'MenuBar',
        name: '11 pt',
    },
    {
        id: 1936292358,
        label: 'Type > Size > 12 pt',
        placement: 'MenuBar',
        name: '12 pt',
    },
    {
        id: 1936292359,
        label: 'Type > Size > 14 pt',
        placement: 'MenuBar',
        name: '14 pt',
    },
    {
        id: 1936292360,
        label: 'Type > Size > 18 pt',
        placement: 'MenuBar',
        name: '18 pt',
    },
    {
        id: 1936292361,
        label: 'Type > Size > 21 pt',
        placement: 'MenuBar',
        name: '21 pt',
    },
    {
        id: 1936292362,
        label: 'Type > Size > 24 pt',
        placement: 'MenuBar',
        name: '24 pt',
    },
    {
        id: 1936292363,
        label: 'Type > Size > 36 pt',
        placement: 'MenuBar',
        name: '36 pt',
    },
    {
        id: 1936292364,
        label: 'Type > Size > 48 pt',
        placement: 'MenuBar',
        name: '48 pt',
    },
    {
        id: 1936292365,
        label: 'Type > Size > 60 pt',
        placement: 'MenuBar',
        name: '60 pt',
    },
    {
        id: 1936292366,
        label: 'Type > Size > 72 pt',
        placement: 'MenuBar',
        name: '72 pt',
    },
    {
        id: 1936292367,
        label: 'Type > Size > Other...',
        placement: 'MenuBar',
        name: 'Other...',
    },
    {
        id: 1937138035,
        label: 'File > Save As...',
        placement: 'MenuBar',
        name: 'Save As...',
    },
    {
        id: 1970168943,
        label: 'Edit > Undo',
        placement: 'MenuBar',
        name: 'Undo',
    },
    {
        id: 2164260867,
        label: 'Help > Manage My Account...',
        placement: 'MenuBar',
        name: 'Manage My Account...',
    },
    {
        id: 2164260869,
        label: 'Help > Updates...',
        placement: 'MenuBar',
        name: 'Updates...',
    },
    {
        id: 2164260870,
        label: 'Effect > Apply Last Effect',
        placement: 'MenuBar',
        name: 'Apply Last Effect',
    },
    {
        id: 2164260871,
        label: 'Effect > Last Effect',
        placement: 'MenuBar',
        name: 'Last Effect',
    },
    {
        id: 2164260872,
        label: 'File > Search Adobe Stock...',
        placement: 'MenuBar',
        name: 'Search Adobe Stock...',
    },
    {
        id: 2164260873,
        label: 'File > Place...',
        placement: 'MenuBar',
        name: 'Place...',
    },
    {
        id: 2164260874,
        label: 'Object > Path > Remove Anchor Points',
        placement: 'MenuBar',
        name: 'Remove Anchor Points',
    },
    {
        id: 2164260877,
        label: 'Help > Debug > Memory Use Checkpoint',
        placement: 'MenuBar',
        name: 'Memory Use Checkpoint',
    },
    {
        id: 2164260878,
        label: 'Help > Debug > Save Memory Use',
        placement: 'MenuBar',
        name: 'Save Memory Use',
    },
    {
        id: 2164260880,
        label: 'Help > Debug > Progress: Bar Shown',
        placement: 'MenuBar',
        name: 'Progress: Bar Shown',
    },
    {
        id: 2164260881,
        label: 'Help > Debug > Progress: Tight loop for 120 Seconds',
        placement: 'MenuBar',
        name: 'Progress: Tight loop for 120 Seconds',
    },
    {
        id: 2164260882,
        label: 'Help > Debug > Responsive Rate Test',
        placement: 'MenuBar',
        name: 'Responsive Rate Test',
    },
    {
        id: 2164260883,
        label: 'Help > Debug > Test Notification 1',
        placement: 'MenuBar',
        name: 'Test Notification 1',
    },
    {
        id: 2164260884,
        label: 'Help > Debug > Test Notification 2',
        placement: 'MenuBar',
        name: 'Test Notification 2',
    },
    {
        id: 2164260885,
        label: 'Help > Debug > Test Notification 3',
        placement: 'MenuBar',
        name: 'Test Notification 3',
    },
    {
        id: 2164260887,
        label: 'Help > Debug > Count Objects',
        placement: 'MenuBar',
        name: 'Count Objects',
    },
    {
        id: 2164260888,
        label: 'Help > Debug > Object Counts',
        placement: 'MenuBar',
        name: 'Object Counts',
    },
    {
        id: 2164260890,
        label: 'Help > Debug > Track API Refs',
        placement: 'MenuBar',
        name: 'Track API Refs',
    },
    {
        id: 2164260891,
        label: 'Help > Debug > Process Deep Link',
        placement: 'MenuBar',
        name: 'Process Deep Link',
    },
    {
        id: 2164260892,
        label: 'Help > Debug > Start Discover Panel Tour',
        placement: 'MenuBar',
        name: 'Start Discover Panel Tour',
    },
    {
        id: 2164260894,
        label: 'Help > Debug > Enable New Rendering',
        placement: 'MenuBar',
        name: 'Enable New Rendering',
    },
    {
        id: 2164260895,
        label: 'Help > Debug > Enable Rendering Timer',
        placement: 'MenuBar',
        name: 'Enable Rendering Timer',
    },
    {
        id: 2164260896,
        label: 'Help > Debug > Purge Rendering Cache',
        placement: 'MenuBar',
        name: 'Purge Rendering Cache',
    },
    {
        id: 2164260897,
        label: 'Help > Debug > Redraw',
        placement: 'MenuBar',
        name: 'Redraw',
    },
    {
        id: 2164260898,
        label: 'Help > Debug > Dump Application Heap Used',
        placement: 'MenuBar',
        name: 'Dump Application Heap Used',
    },
    {
        id: 2164260899,
        label: 'Help > Debug > Disable Greeking for New Rendering',
        placement: 'MenuBar',
        name: 'Disable Greeking for New Rendering',
    },
    {
        id: 2164260900,
        label: 'Help > Debug > Enable Threaded Rendering',
        placement: 'MenuBar',
        name: 'Enable Threaded Rendering',
    },
    {
        id: 2164260901,
        label: 'Help > Debug > Enable AGM Threading',
        placement: 'MenuBar',
        name: 'Enable AGM Threading',
    },
    {
        id: 2164260902,
        label: 'Help > Debug > Enable AGM Internal Memory Pool',
        placement: 'MenuBar',
        name: 'Enable AGM Internal Memory Pool',
    },
    {
        id: 2164260903,
        label: 'Help > Debug > Enable QuickPort Quartz',
        placement: 'MenuBar',
        name: 'Enable QuickPort Quartz',
    },
    {
        id: 2164260904,
        label: 'Help > Debug > Crash',
        placement: 'MenuBar',
        name: 'Crash',
    },
    {
        id: 2164260906,
        label: 'Help > Debug > Enable PGF Recovery',
        placement: 'MenuBar',
        name: 'Enable PGF Recovery',
    },
    {
        id: 2164260907,
        label: 'Help > Debug > Enable ATE Read Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Read Recovery',
    },
    {
        id: 2164260908,
        label: 'Help > Debug > Enable ATE Write Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Write Recovery',
    },
    {
        id: 2164260910,
        label: 'Window > Info',
        placement: 'MenuBar',
        name: 'Info',
    },
    {
        id: 2164260912,
        label: 'Window > Type > Character',
        placement: 'MenuBar',
        name: 'Character',
    },
    {
        id: 2164260913,
        label: 'Window > Type > Paragraph',
        placement: 'MenuBar',
        name: 'Paragraph',
    },
    {
        id: 2164260914,
        label: 'Window > Type > Tabs',
        placement: 'MenuBar',
        name: 'Tabs',
    },
    {
        id: 2164260915,
        label: 'Window > Type > OpenType',
        placement: 'MenuBar',
        name: 'OpenType',
    },
    {
        id: 2164260916,
        label: 'Effect > Photoshop Effects',
        placement: 'MenuBar',
        name: 'Photoshop Effects',
    },
    {
        id: 2164260919,
        label: 'Effect > Blur > Smart Blur...',
        placement: 'MenuBar',
        name: 'Smart Blur...',
    },
    {
        id: 2164260920,
        label: 'Effect > Blur > Radial Blur...',
        placement: 'MenuBar',
        name: 'Radial Blur...',
    },
    {
        id: 2164260922,
        label: 'Effect > Pixelate > Pointillize...',
        placement: 'MenuBar',
        name: 'Pointillize...',
    },
    {
        id: 2164260923,
        label: 'Effect > Pixelate > Mezzotint...',
        placement: 'MenuBar',
        name: 'Mezzotint...',
    },
    {
        id: 2164260925,
        label: 'Effect > Video > De-Interlace...',
        placement: 'MenuBar',
        name: 'De-Interlace...',
    },
    {
        id: 2164260926,
        label: 'Effect > Pixelate > Crystallize...',
        placement: 'MenuBar',
        name: 'Crystallize...',
    },
    {
        id: 2164260927,
        label: 'Effect > Pixelate > Color Halftone...',
        placement: 'MenuBar',
        name: 'Color Halftone...',
    },
    {
        id: 2164260928,
        label: 'Effect > Video > NTSC Colors',
        placement: 'MenuBar',
        name: 'NTSC Colors',
    },
    {
        id: 2164260930,
        label: 'Effect > Artistic > Watercolor...',
        placement: 'MenuBar',
        name: 'Watercolor...',
    },
    {
        id: 2164260932,
        label: 'Effect > Sketch > Water Paper...',
        placement: 'MenuBar',
        name: 'Water Paper...',
    },
    {
        id: 2164260933,
        label: 'Effect > Artistic > Underpainting...',
        placement: 'MenuBar',
        name: 'Underpainting...',
    },
    {
        id: 2164260934,
        label: 'Effect > Sketch > Torn Edges...',
        placement: 'MenuBar',
        name: 'Torn Edges...',
    },
    {
        id: 2164260936,
        label: 'Effect > Texture > Texturizer...',
        placement: 'MenuBar',
        name: 'Texturizer...',
    },
    {
        id: 2164260938,
        label: 'Effect > Brush Strokes > Sumi-e...',
        placement: 'MenuBar',
        name: 'Sumi-e...',
    },
    {
        id: 2164260939,
        label: 'Effect > Sketch > Stamp...',
        placement: 'MenuBar',
        name: 'Stamp...',
    },
    {
        id: 2164260940,
        label: 'Effect > Texture > Stained Glass...',
        placement: 'MenuBar',
        name: 'Stained Glass...',
    },
    {
        id: 2164260941,
        label: 'Effect > Brush Strokes > Sprayed Strokes...',
        placement: 'MenuBar',
        name: 'Sprayed Strokes...',
    },
    {
        id: 2164260942,
        label: 'Effect > Artistic > Sponge...',
        placement: 'MenuBar',
        name: 'Sponge...',
    },
    {
        id: 2164260943,
        label: 'Effect > Brush Strokes > Spatter...',
        placement: 'MenuBar',
        name: 'Spatter...',
    },
    {
        id: 2164260944,
        label: 'Effect > Artistic > Smudge Stick...',
        placement: 'MenuBar',
        name: 'Smudge Stick...',
    },
    {
        id: 2164260945,
        label: 'Effect > Artistic > Rough Pastels...',
        placement: 'MenuBar',
        name: 'Rough Pastels...',
    },
    {
        id: 2164260946,
        label: 'Effect > Sketch > Reticulation...',
        placement: 'MenuBar',
        name: 'Reticulation...',
    },
    {
        id: 2164260947,
        label: 'Effect > Artistic > Poster Edges...',
        placement: 'MenuBar',
        name: 'Poster Edges...',
    },
    {
        id: 2164260948,
        label: 'Effect > Artistic > Plastic Wrap...',
        placement: 'MenuBar',
        name: 'Plastic Wrap...',
    },
    {
        id: 2164260949,
        label: 'Effect > Sketch > Plaster...',
        placement: 'MenuBar',
        name: 'Plaster...',
    },
    {
        id: 2164260950,
        label: 'Effect > Sketch > Photocopy...',
        placement: 'MenuBar',
        name: 'Photocopy...',
    },
    {
        id: 2164260951,
        label: 'Effect > Texture > Patchwork...',
        placement: 'MenuBar',
        name: 'Patchwork...',
    },
    {
        id: 2164260952,
        label: 'Effect > Artistic > Palette Knife...',
        placement: 'MenuBar',
        name: 'Palette Knife...',
    },
    {
        id: 2164260953,
        label: 'Effect > Artistic > Paint Daubs...',
        placement: 'MenuBar',
        name: 'Paint Daubs...',
    },
    {
        id: 2164260955,
        label: 'Effect > Distort > Ocean Ripple...',
        placement: 'MenuBar',
        name: 'Ocean Ripple...',
    },
    {
        id: 2164260956,
        label: 'Effect > Sketch > Note Paper...',
        placement: 'MenuBar',
        name: 'Note Paper...',
    },
    {
        id: 2164260957,
        label: 'Effect > Artistic > Neon Glow...',
        placement: 'MenuBar',
        name: 'Neon Glow...',
    },
    {
        id: 2164260958,
        label: 'Effect > Texture > Mosaic Tiles...',
        placement: 'MenuBar',
        name: 'Mosaic Tiles...',
    },
    {
        id: 2164260959,
        label: 'Effect > Brush Strokes > Ink Outlines...',
        placement: 'MenuBar',
        name: 'Ink Outlines...',
    },
    {
        id: 2164260960,
        label: 'Effect > Sketch > Halftone Pattern...',
        placement: 'MenuBar',
        name: 'Halftone Pattern...',
    },
    {
        id: 2164260961,
        label: 'Effect > Sketch > Graphic Pen...',
        placement: 'MenuBar',
        name: 'Graphic Pen...',
    },
    {
        id: 2164260962,
        label: 'Effect > Texture > Grain...',
        placement: 'MenuBar',
        name: 'Grain...',
    },
    {
        id: 2164260964,
        label: 'Effect > Stylize > Glowing Edges...',
        placement: 'MenuBar',
        name: 'Glowing Edges...',
    },
    {
        id: 2164260965,
        label: 'Effect > Distort > Glass...',
        placement: 'MenuBar',
        name: 'Glass...',
    },
    {
        id: 2164260966,
        label: 'Effect > Artistic > Fresco...',
        placement: 'MenuBar',
        name: 'Fresco...',
    },
    {
        id: 2164260967,
        label: 'Effect > Artistic > Film Grain...',
        placement: 'MenuBar',
        name: 'Film Grain...',
    },
    {
        id: 2164260968,
        label: 'Effect > Artistic > Dry Brush...',
        placement: 'MenuBar',
        name: 'Dry Brush...',
    },
    {
        id: 2164260969,
        label: 'Effect > Distort > Diffuse Glow...',
        placement: 'MenuBar',
        name: 'Diffuse Glow...',
    },
    {
        id: 2164260970,
        label: 'Effect > Brush Strokes > Dark Strokes...',
        placement: 'MenuBar',
        name: 'Dark Strokes...',
    },
    {
        id: 2164260971,
        label: 'Effect > Artistic > Cutout...',
        placement: 'MenuBar',
        name: 'Cutout...',
    },
    {
        id: 2164260972,
        label: 'Effect > Brush Strokes > Crosshatch...',
        placement: 'MenuBar',
        name: 'Crosshatch...',
    },
    {
        id: 2164260973,
        label: 'Effect > Texture > Craquelure...',
        placement: 'MenuBar',
        name: 'Craquelure...',
    },
    {
        id: 2164260974,
        label: 'Effect > Sketch > Conté Crayon...',
        placement: 'MenuBar',
        name: 'Conté Crayon...',
    },
    {
        id: 2164260975,
        label: 'Effect > Artistic > Colored Pencil...',
        placement: 'MenuBar',
        name: 'Colored Pencil...',
    },
    {
        id: 2164260976,
        label: 'Effect > Sketch > Chrome...',
        placement: 'MenuBar',
        name: 'Chrome...',
    },
    {
        id: 2164260977,
        label: 'Effect > Sketch > Charcoal...',
        placement: 'MenuBar',
        name: 'Charcoal...',
    },
    {
        id: 2164260978,
        label: 'Effect > Sketch > Chalk & Charcoal...',
        placement: 'MenuBar',
        name: 'Chalk & Charcoal...',
    },
    {
        id: 2164260979,
        label: 'Effect > Sketch > Bas Relief...',
        placement: 'MenuBar',
        name: 'Bas Relief...',
    },
    {
        id: 2164260980,
        label: 'Effect > Brush Strokes > Angled Strokes...',
        placement: 'MenuBar',
        name: 'Angled Strokes...',
    },
    {
        id: 2164260981,
        label: 'Effect > Brush Strokes > Accented Edges...',
        placement: 'MenuBar',
        name: 'Accented Edges...',
    },
    {
        id: 2164260982,
        label: 'Effect > Effect Gallery...',
        placement: 'MenuBar',
        name: 'Effect Gallery...',
    },
    {
        id: 2164260983,
        label: 'Edit > Edit Custom Dictionary...',
        placement: 'MenuBar',
        name: 'Edit Custom Dictionary...',
    },
    {
        id: 2164260986,
        label: 'Object > Path > Split Into Grid...',
        placement: 'MenuBar',
        name: 'Split Into Grid...',
    },
    {
        id: 2164260988,
        label: 'Type > Change Case > UPPERCASE',
        placement: 'MenuBar',
        name: 'UPPERCASE',
    },
    {
        id: 2164260989,
        label: 'Type > Change Case > lowercase',
        placement: 'MenuBar',
        name: 'lowercase',
    },
    {
        id: 2164260990,
        label: 'Type > Change Case > Title Case',
        placement: 'MenuBar',
        name: 'Title Case',
    },
    {
        id: 2164260991,
        label: 'Type > Change Case > Sentence case',
        placement: 'MenuBar',
        name: 'Sentence case',
    },
    {
        id: 2164260992,
        label: 'Type > Optical Margin Alignment',
        placement: 'MenuBar',
        name: 'Optical Margin Alignment',
    },
    {
        id: 2164260993,
        label: 'Type > Find/Replace Font...',
        placement: 'MenuBar',
        name: 'Find/Replace Font...',
    },
    {
        id: 2164260994,
        label: 'Type > Smart Punctuation...',
        placement: 'MenuBar',
        name: 'Smart Punctuation...',
    },
    {
        id: 2164260995,
        label: 'Effect > Illustrator Effects',
        placement: 'MenuBar',
        name: 'Illustrator Effects',
    },
    {
        id: 2164260998,
        label: 'Effect > Distort & Transform > Transform...',
        placement: 'MenuBar',
        name: 'Transform...',
    },
    {
        id: 2164260999,
        label: 'Object > Transform > Transform Each...',
        placement: 'MenuBar',
        name: 'Transform Each...',
    },
    {
        id: 2164261001,
        label: 'Window > Libraries',
        placement: 'MenuBar',
        name: 'Libraries',
    },
    {
        id: 2164261003,
        label: 'Window > Find Extensions on Exchange...',
        placement: 'MenuBar',
        name: 'Find Extensions on Exchange...',
    },
    {
        id: 2164261004,
        label: 'Object > Create Gradient Mesh...',
        placement: 'MenuBar',
        name: 'Create Gradient Mesh...',
    },
    {
        id: 2164261005,
        label: 'Window > Separations Preview',
        placement: 'MenuBar',
        name: 'Separations Preview',
    },
    {
        id: 2164261006,
        label: 'Window > Links',
        placement: 'MenuBar',
        name: 'Links',
    },
    {
        id: 2164261008,
        label: 'Edit > Edit Original',
        placement: 'MenuBar',
        name: 'Edit Original',
    },
    {
        id: 2164261010,
        label: 'Window > Type > Paragraph Styles',
        placement: 'MenuBar',
        name: 'Paragraph Styles',
    },
    {
        id: 2164261011,
        label: 'Window > Type > Character Styles',
        placement: 'MenuBar',
        name: 'Character Styles',
    },
    {
        id: 2164261012,
        label: 'Window > Artboards',
        placement: 'MenuBar',
        name: 'Artboards',
    },
    {
        id: 2164261014,
        label: 'Object > Artboards > Rearrange All Artboards',
        placement: 'MenuBar',
        name: 'Rearrange All Artboards',
    },
    {
        id: 2164261016,
        label: 'Object > Artboards > Fit to Artwork Bounds',
        placement: 'MenuBar',
        name: 'Fit to Artwork Bounds',
    },
    {
        id: 2164261017,
        label: 'Object > Artboards > Fit to Selected Art',
        placement: 'MenuBar',
        name: 'Fit to Selected Art',
    },
    {
        id: 2164261018,
        label: 'Window > Properties',
        placement: 'MenuBar',
        name: 'Properties',
    },
    {
        id: 2164261019,
        label: 'Window > Navigator',
        placement: 'MenuBar',
        name: 'Navigator',
    },
    {
        id: 2164261022,
        label: 'Window > Workspace > Reset Getting Started',
        placement: 'MenuBar',
        name: 'Reset Getting Started',
    },
    {
        id: 2164261023,
        label: 'Window > Workspace > New Workspace...',
        placement: 'MenuBar',
        name: 'New Workspace...',
    },
    {
        id: 2164261024,
        label: 'Window > Workspace > Manage Workspaces...',
        placement: 'MenuBar',
        name: 'Manage Workspaces...',
    },
    {
        id: 2164261025,
        label: 'Window > Workspace > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261026,
        label: 'Window > Workspace > Tracing',
        placement: 'MenuBar',
        name: 'Tracing',
    },
    {
        id: 2164261027,
        label: 'Window > Workspace > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261028,
        label: 'Window > Workspace > Layout',
        placement: 'MenuBar',
        name: 'Layout',
    },
    {
        id: 2164261029,
        label: 'Window > Workspace > Essentials Classic',
        placement: 'MenuBar',
        name: 'Essentials Classic',
    },
    {
        id: 2164261030,
        label: 'Window > Workspace > Painting',
        placement: 'MenuBar',
        name: 'Painting',
    },
    {
        id: 2164261031,
        label: 'Window > Workspace > Typography',
        placement: 'MenuBar',
        name: 'Typography',
    },
    {
        id: 2164261032,
        label: 'Window > Workspace > Automation',
        placement: 'MenuBar',
        name: 'Automation',
    },
    {
        id: 2164261033,
        label: 'Window > Workspace > Essentials',
        placement: 'MenuBar',
        name: 'Essentials',
    },
    {
        id: 2164261034,
        label: 'Window > Workspace > Printing and Proofing',
        placement: 'MenuBar',
        name: 'Printing and Proofing',
    },
    {
        id: 2164261035,
        label: 'Edit > Keyboard Shortcuts...',
        placement: 'MenuBar',
        name: 'Keyboard Shortcuts...',
    },
    {
        id: 2164261036,
        label: 'Window > Graphic Styles',
        placement: 'MenuBar',
        name: 'Graphic Styles',
    },
    {
        id: 2164261037,
        label: 'Window > Appearance',
        placement: 'MenuBar',
        name: 'Appearance',
    },
    {
        id: 2164261043,
        label: 'Window > Graphic Style Libraries > 3D Effects',
        placement: 'MenuBar',
        name: '3D Effects',
    },
    {
        id: 2164261044,
        label: 'Window > Graphic Style Libraries > Additive for Blob Brush',
        placement: 'MenuBar',
        name: 'Additive for Blob Brush',
    },
    {
        id: 2164261045,
        label: 'Window > Graphic Style Libraries > Additive',
        placement: 'MenuBar',
        name: 'Additive',
    },
    {
        id: 2164261046,
        label: 'Window > Graphic Style Libraries > Artistic Effects',
        placement: 'MenuBar',
        name: 'Artistic Effects',
    },
    {
        id: 2164261047,
        label: 'Window > Graphic Style Libraries > Buttons and Rollovers',
        placement: 'MenuBar',
        name: 'Buttons and Rollovers',
    },
    {
        id: 2164261048,
        label: 'Window > Graphic Style Libraries > Illuminate Styles',
        placement: 'MenuBar',
        name: 'Illuminate Styles',
    },
    {
        id: 2164261049,
        label: 'Window > Graphic Style Libraries > Image Effects',
        placement: 'MenuBar',
        name: 'Image Effects',
    },
    {
        id: 2164261050,
        label: 'Window > Graphic Style Libraries > Neon Effects',
        placement: 'MenuBar',
        name: 'Neon Effects',
    },
    {
        id: 2164261051,
        label: 'Window > Graphic Style Libraries > Scribble Effects',
        placement: 'MenuBar',
        name: 'Scribble Effects',
    },
    {
        id: 2164261052,
        label: 'Window > Graphic Style Libraries > Textures',
        placement: 'MenuBar',
        name: 'Textures',
    },
    {
        id: 2164261053,
        label: 'Window > Graphic Style Libraries > Type Effects',
        placement: 'MenuBar',
        name: 'Type Effects',
    },
    {
        id: 2164261054,
        label: 'Window > Graphic Style Libraries > Vonster Pattern Styles',
        placement: 'MenuBar',
        name: 'Vonster Pattern Styles',
    },
    {
        id: 2164261057,
        label: 'Window > Graphic Style Libraries > Other Library...',
        placement: 'MenuBar',
        name: 'Other Library...',
    },
    {
        id: 2164261058,
        label: 'Window > Symbols',
        placement: 'MenuBar',
        name: 'Symbols',
    },
    {
        id: 2164261060,
        label: 'Window > Symbol Libraries > 3D Symbols',
        placement: 'MenuBar',
        name: '3D Symbols',
    },
    {
        id: 2164261061,
        label: 'Window > Symbol Libraries > Arrows',
        placement: 'MenuBar',
        name: 'Arrows',
    },
    {
        id: 2164261062,
        label: 'Window > Symbol Libraries > Artistic Textures',
        placement: 'MenuBar',
        name: 'Artistic Textures',
    },
    {
        id: 2164261063,
        label: 'Window > Symbol Libraries > Celebration',
        placement: 'MenuBar',
        name: 'Celebration',
    },
    {
        id: 2164261064,
        label: 'Window > Symbol Libraries > Charts',
        placement: 'MenuBar',
        name: 'Charts',
    },
    {
        id: 2164261065,
        label: 'Window > Symbol Libraries > Communication',
        placement: 'MenuBar',
        name: 'Communication',
    },
    {
        id: 2164261066,
        label: 'Window > Symbol Libraries > Dot Pattern Vector Pack',
        placement: 'MenuBar',
        name: 'Dot Pattern Vector Pack',
    },
    {
        id: 2164261067,
        label: 'Window > Symbol Libraries > Fashion',
        placement: 'MenuBar',
        name: 'Fashion',
    },
    {
        id: 2164261068,
        label: 'Window > Symbol Libraries > Florid Vector Pack',
        placement: 'MenuBar',
        name: 'Florid Vector Pack',
    },
    {
        id: 2164261069,
        label: 'Window > Symbol Libraries > Flowers',
        placement: 'MenuBar',
        name: 'Flowers',
    },
    {
        id: 2164261070,
        label: 'Window > Symbol Libraries > Grime Vector Pack',
        placement: 'MenuBar',
        name: 'Grime Vector Pack',
    },
    {
        id: 2164261071,
        label: 'Window > Symbol Libraries > Hair and Fur',
        placement: 'MenuBar',
        name: 'Hair and Fur',
    },
    {
        id: 2164261072,
        label: 'Window > Symbol Libraries > Heirloom',
        placement: 'MenuBar',
        name: 'Heirloom',
    },
    {
        id: 2164261073,
        label: 'Window > Symbol Libraries > Illuminate Flow Charts',
        placement: 'MenuBar',
        name: 'Illuminate Flow Charts',
    },
    {
        id: 2164261074,
        label: 'Window > Symbol Libraries > Illuminate Org Charts',
        placement: 'MenuBar',
        name: 'Illuminate Org Charts',
    },
    {
        id: 2164261075,
        label: 'Window > Symbol Libraries > Illuminate Ribbons',
        placement: 'MenuBar',
        name: 'Illuminate Ribbons',
    },
    {
        id: 2164261076,
        label: 'Window > Symbol Libraries > Indigenous',
        placement: 'MenuBar',
        name: 'Indigenous',
    },
    {
        id: 2164261077,
        label: 'Window > Symbol Libraries > Logo Elements',
        placement: 'MenuBar',
        name: 'Logo Elements',
    },
    {
        id: 2164261078,
        label: 'Window > Symbol Libraries > Mad Science',
        placement: 'MenuBar',
        name: 'Mad Science',
    },
    {
        id: 2164261079,
        label: 'Window > Symbol Libraries > Maps',
        placement: 'MenuBar',
        name: 'Maps',
    },
    {
        id: 2164261080,
        label: 'Window > Symbol Libraries > Mobile',
        placement: 'MenuBar',
        name: 'Mobile',
    },
    {
        id: 2164261081,
        label: 'Window > Symbol Libraries > Nature',
        placement: 'MenuBar',
        name: 'Nature',
    },
    {
        id: 2164261082,
        label: 'Window > Symbol Libraries > Regal Vector Pack',
        placement: 'MenuBar',
        name: 'Regal Vector Pack',
    },
    {
        id: 2164261083,
        label: 'Window > Symbol Libraries > Retro',
        placement: 'MenuBar',
        name: 'Retro',
    },
    {
        id: 2164261084,
        label: 'Window > Symbol Libraries > Sushi',
        placement: 'MenuBar',
        name: 'Sushi',
    },
    {
        id: 2164261085,
        label: 'Window > Symbol Libraries > Tiki',
        placement: 'MenuBar',
        name: 'Tiki',
    },
    {
        id: 2164261086,
        label: 'Window > Symbol Libraries > Web Buttons and Bars',
        placement: 'MenuBar',
        name: 'Web Buttons and Bars',
    },
    {
        id: 2164261087,
        label: 'Window > Symbol Libraries > Web Icons',
        placement: 'MenuBar',
        name: 'Web Icons',
    },
    {
        id: 2164261090,
        label: 'Window > Symbol Libraries > Other Library...',
        placement: 'MenuBar',
        name: 'Other Library...',
    },
    {
        id: 2164261092,
        label: 'View > Smart Guides',
        placement: 'MenuBar',
        name: 'Smart Guides',
    },
    {
        id: 2164261093,
        label: 'Window > Flattener Preview',
        placement: 'MenuBar',
        name: 'Flattener Preview',
    },
    {
        id: 2164261094,
        label: 'Window > History',
        placement: 'MenuBar',
        name: 'History',
    },
    {
        id: 2164261096,
        label: 'Type > Glyphs',
        placement: 'MenuBar',
        name: 'Glyphs',
    },
    {
        id: 2164261097,
        label: 'Window > Type > Glyphs',
        placement: 'MenuBar',
        name: 'Glyphs',
    },
    {
        id: 2164261098,
        label: 'Window > Actions',
        placement: 'MenuBar',
        name: 'Actions',
    },
    {
        id: 2164261100,
        label: 'Select > Inverse',
        placement: 'MenuBar',
        name: 'Inverse',
    },
    {
        id: 2164261102,
        label: 'Effect > Stylize > Drop Shadow...',
        placement: 'MenuBar',
        name: 'Drop Shadow...',
    },
    {
        id: 2164261103,
        label: 'Effect > Stylize > Outer Glow...',
        placement: 'MenuBar',
        name: 'Outer Glow...',
    },
    {
        id: 2164261104,
        label: 'Effect > Stylize > Inner Glow...',
        placement: 'MenuBar',
        name: 'Inner Glow...',
    },
    {
        id: 2164261106,
        label: 'Effect > Convert to Shape > Rectangle...',
        placement: 'MenuBar',
        name: 'Rectangle...',
    },
    {
        id: 2164261107,
        label: 'Effect > Convert to Shape > Rounded Rectangle...',
        placement: 'MenuBar',
        name: 'Rounded Rectangle...',
    },
    {
        id: 2164261108,
        label: 'Effect > Convert to Shape > Ellipse...',
        placement: 'MenuBar',
        name: 'Ellipse...',
    },
    {
        id: 2164261109,
        label: 'Effect > Stylize > Round Corners...',
        placement: 'MenuBar',
        name: 'Round Corners...',
    },
    {
        id: 2164261111,
        label: 'Object > Path > Clean Up...',
        placement: 'MenuBar',
        name: 'Clean Up...',
    },
    {
        id: 2164261113,
        label: 'Edit > Edit Colors > Overprint Black...',
        placement: 'MenuBar',
        name: 'Overprint Black...',
    },
    {
        id: 2164261114,
        label: 'Effect > Distort & Transform > Free Distort...',
        placement: 'MenuBar',
        name: 'Free Distort...',
    },
    {
        id: 2164261115,
        label: 'Effect > Distort & Transform > Pucker & Bloat...',
        placement: 'MenuBar',
        name: 'Pucker & Bloat...',
    },
    {
        id: 2164261117,
        label: 'Object > Text Wrap > Make',
        placement: 'MenuBar',
        name: 'Make',
    },
    {
        id: 2164261118,
        label: 'Object > Text Wrap > Release',
        placement: 'MenuBar',
        name: 'Release',
    },
    {
        id: 2164261120,
        label: 'Object > Text Wrap > Text Wrap Options...',
        placement: 'MenuBar',
        name: 'Text Wrap Options...',
    },
    {
        id: 2164261121,
        label: 'Effect > Distort & Transform > Tweak...',
        placement: 'MenuBar',
        name: 'Tweak...',
    },
    {
        id: 2164261122,
        label: 'Select > Object > Clipping Masks',
        placement: 'MenuBar',
        name: 'Clipping Masks',
    },
    {
        id: 2164261123,
        label: 'Edit > Edit Colors > Blend Front to Back',
        placement: 'MenuBar',
        name: 'Blend Front to Back',
    },
    {
        id: 2164261124,
        label: 'Edit > Edit Colors > Blend Horizontally',
        placement: 'MenuBar',
        name: 'Blend Horizontally',
    },
    {
        id: 2164261125,
        label: 'Edit > Edit Colors > Blend Vertically',
        placement: 'MenuBar',
        name: 'Blend Vertically',
    },
    {
        id: 2164261126,
        label: 'Edit > Edit Colors > Invert Colors',
        placement: 'MenuBar',
        name: 'Invert Colors',
    },
    {
        id: 2164261127,
        label: 'Edit > Edit Colors > Convert to Grayscale',
        placement: 'MenuBar',
        name: 'Convert to Grayscale',
    },
    {
        id: 2164261128,
        label: 'Edit > Edit Colors > Convert to CMYK',
        placement: 'MenuBar',
        name: 'Convert to CMYK',
    },
    {
        id: 2164261129,
        label: 'Edit > Edit Colors > Convert to RGB',
        placement: 'MenuBar',
        name: 'Convert to RGB',
    },
    {
        id: 2164261130,
        label: 'Edit > Edit Colors > Saturate...',
        placement: 'MenuBar',
        name: 'Saturate...',
    },
    {
        id: 2164261132,
        label: 'Object > Path > Add Anchor Points',
        placement: 'MenuBar',
        name: 'Add Anchor Points',
    },
    {
        id: 2164261133,
        label: 'Edit > Edit Colors > Adjust Color Balance...',
        placement: 'MenuBar',
        name: 'Adjust Color Balance...',
    },
    {
        id: 2164261134,
        label: 'Object > Create Object Mosaic...',
        placement: 'MenuBar',
        name: 'Create Object Mosaic...',
    },
    {
        id: 2164261135,
        label: 'Effect > Distort & Transform > Roughen...',
        placement: 'MenuBar',
        name: 'Roughen...',
    },
    {
        id: 2164261136,
        label: 'Select > Reselect',
        placement: 'MenuBar',
        name: 'Reselect',
    },
    {
        id: 2164261138,
        label: 'Select > Same > Shapes & Text',
        placement: 'MenuBar',
        name: 'Shapes & Text',
    },
    {
        id: 2164261139,
        label: 'Select > Same > Text',
        placement: 'MenuBar',
        name: 'Text',
    },
    {
        id: 2164261141,
        label: 'Select > Same > Fill Color',
        placement: 'MenuBar',
        name: 'Fill Color',
    },
    {
        id: 2164261142,
        label: 'Select > Same > Graphic Style',
        placement: 'MenuBar',
        name: 'Graphic Style',
    },
    {
        id: 2164261143,
        label: 'Select > Same > Fill & Stroke',
        placement: 'MenuBar',
        name: 'Fill & Stroke',
    },
    {
        id: 2164261144,
        label: 'Select > Same > Stroke Color',
        placement: 'MenuBar',
        name: 'Stroke Color',
    },
    {
        id: 2164261145,
        label: 'Select > Same > Stroke Weight',
        placement: 'MenuBar',
        name: 'Stroke Weight',
    },
    {
        id: 2164261146,
        label: 'Select > Same > Blending Mode',
        placement: 'MenuBar',
        name: 'Blending Mode',
    },
    {
        id: 2164261147,
        label: 'Select > Same > Opacity',
        placement: 'MenuBar',
        name: 'Opacity',
    },
    {
        id: 2164261148,
        label: 'Select > Same > Shape',
        placement: 'MenuBar',
        name: 'Shape',
    },
    {
        id: 2164261149,
        label: 'Select > Same > Symbol Instance',
        placement: 'MenuBar',
        name: 'Symbol Instance',
    },
    {
        id: 2164261150,
        label: 'Select > Same > Link Block Series',
        placement: 'MenuBar',
        name: 'Link Block Series',
    },
    {
        id: 2164261151,
        label: 'Select > Same > Appearance',
        placement: 'MenuBar',
        name: 'Appearance',
    },
    {
        id: 2164261152,
        label: 'Select > Same > Appearance Attribute',
        placement: 'MenuBar',
        name: 'Appearance Attribute',
    },
    {
        id: 2164261153,
        label: 'Select > Same > Text Fill Color',
        placement: 'MenuBar',
        name: 'Text Fill Color',
    },
    {
        id: 2164261154,
        label: 'Select > Same > Text Stroke Color',
        placement: 'MenuBar',
        name: 'Text Stroke Color',
    },
    {
        id: 2164261155,
        label: 'Select > Same > Text Fill & Stroke Color',
        placement: 'MenuBar',
        name: 'Text Fill & Stroke Color',
    },
    {
        id: 2164261156,
        label: 'Select > Same > Font Size',
        placement: 'MenuBar',
        name: 'Font Size',
    },
    {
        id: 2164261157,
        label: 'Select > Same > Font Family',
        placement: 'MenuBar',
        name: 'Font Family',
    },
    {
        id: 2164261158,
        label: 'Select > Same > Font Family & Style',
        placement: 'MenuBar',
        name: 'Font Family & Style',
    },
    {
        id: 2164261159,
        label: 'Select > Same > Font Family, Style & Size',
        placement: 'MenuBar',
        name: 'Font Family, Style & Size',
    },
    {
        id: 2164261160,
        label: 'Select > Object > Stray Points',
        placement: 'MenuBar',
        name: 'Stray Points',
    },
    {
        id: 2164261162,
        label: 'Select > Object > All Text Objects',
        placement: 'MenuBar',
        name: 'All Text Objects',
    },
    {
        id: 2164261163,
        label: 'Select > Object > Point Type Objects',
        placement: 'MenuBar',
        name: 'Point Type Objects',
    },
    {
        id: 2164261164,
        label: 'Select > Object > Area Type Objects',
        placement: 'MenuBar',
        name: 'Area Type Objects',
    },
    {
        id: 2164261165,
        label: 'Effect > Distort & Transform > Zig Zag...',
        placement: 'MenuBar',
        name: 'Zig Zag...',
    },
    {
        id: 2164261166,
        label: 'Effect > Crop Marks',
        placement: 'MenuBar',
        name: 'Crop Marks',
    },
    {
        id: 2164261167,
        label: 'Object > Create Trim Marks',
        placement: 'MenuBar',
        name: 'Create Trim Marks',
    },
    {
        id: 2164261168,
        label: 'File > Package...',
        placement: 'MenuBar',
        name: 'Package...',
    },
    {
        id: 2164261169,
        label: 'Window > Layers',
        placement: 'MenuBar',
        name: 'Layers',
    },
    {
        id: 2164261172,
        label: 'File > Browse in Bridge...',
        placement: 'MenuBar',
        name: 'Browse in Bridge...',
    },
    {
        id: 2164261173,
        label: 'File > File Info...',
        placement: 'MenuBar',
        name: 'File Info...',
    },
    {
        id: 2164261174,
        label: 'Window > Document Info',
        placement: 'MenuBar',
        name: 'Document Info',
    },
    {
        id: 2164261176,
        label: 'Effect > Pathfinder > Add',
        placement: 'MenuBar',
        name: 'Add',
    },
    {
        id: 2164261177,
        label: 'Effect > Pathfinder > Intersect',
        placement: 'MenuBar',
        name: 'Intersect',
    },
    {
        id: 2164261178,
        label: 'Effect > Pathfinder > Exclude',
        placement: 'MenuBar',
        name: 'Exclude',
    },
    {
        id: 2164261179,
        label: 'Effect > Pathfinder > Subtract',
        placement: 'MenuBar',
        name: 'Subtract',
    },
    {
        id: 2164261180,
        label: 'Effect > Pathfinder > Minus Back',
        placement: 'MenuBar',
        name: 'Minus Back',
    },
    {
        id: 2164261181,
        label: 'Effect > Pathfinder > Divide',
        placement: 'MenuBar',
        name: 'Divide',
    },
    {
        id: 2164261182,
        label: 'Effect > Pathfinder > Trim',
        placement: 'MenuBar',
        name: 'Trim',
    },
    {
        id: 2164261183,
        label: 'Effect > Pathfinder > Merge',
        placement: 'MenuBar',
        name: 'Merge',
    },
    {
        id: 2164261184,
        label: 'Effect > Pathfinder > Crop',
        placement: 'MenuBar',
        name: 'Crop',
    },
    {
        id: 2164261185,
        label: 'Effect > Pathfinder > Outline',
        placement: 'MenuBar',
        name: 'Outline',
    },
    {
        id: 2164261186,
        label: 'Effect > Pathfinder > Hard Mix',
        placement: 'MenuBar',
        name: 'Hard Mix',
    },
    {
        id: 2164261187,
        label: 'Effect > Pathfinder > Soft Mix...',
        placement: 'MenuBar',
        name: 'Soft Mix...',
    },
    {
        id: 2164261188,
        label: 'Effect > Pathfinder > Trap...',
        placement: 'MenuBar',
        name: 'Trap...',
    },
    {
        id: 2164261189,
        label: 'View > Show Live Paint Gaps',
        placement: 'MenuBar',
        name: 'Show Live Paint Gaps',
    },
    {
        id: 2164261192,
        label: 'Object > Live Paint > Make',
        placement: 'MenuBar',
        name: 'Make',
    },
    {
        id: 2164261193,
        label: 'Object > Live Paint > Merge',
        placement: 'MenuBar',
        name: 'Merge',
    },
    {
        id: 2164261194,
        label: 'Object > Live Paint > Release',
        placement: 'MenuBar',
        name: 'Release',
    },
    {
        id: 2164261196,
        label: 'Object > Live Paint > Gap Options...',
        placement: 'MenuBar',
        name: 'Gap Options...',
    },
    {
        id: 2164261198,
        label: 'Object > Live Paint > Expand',
        placement: 'MenuBar',
        name: 'Expand',
    },
    {
        id: 2164261199,
        label: 'Effect > Stylize > Scribble...',
        placement: 'MenuBar',
        name: 'Scribble...',
    },
    {
        id: 2164261201,
        label: 'Object > Envelope Distort > Make with Warp...',
        placement: 'MenuBar',
        name: 'Make with Warp...',
    },
    {
        id: 2164261202,
        label: 'Object > Envelope Distort > Make with Mesh...',
        placement: 'MenuBar',
        name: 'Make with Mesh...',
    },
    {
        id: 2164261203,
        label: 'Object > Envelope Distort > Make with Top Object',
        placement: 'MenuBar',
        name: 'Make with Top Object',
    },
    {
        id: 2164261204,
        label: 'Object > Envelope Distort > Release',
        placement: 'MenuBar',
        name: 'Release',
    },
    {
        id: 2164261206,
        label: 'Object > Envelope Distort > Envelope Options...',
        placement: 'MenuBar',
        name: 'Envelope Options...',
    },
    {
        id: 2164261208,
        label: 'Object > Envelope Distort > Expand',
        placement: 'MenuBar',
        name: 'Expand',
    },
    {
        id: 2164261210,
        label: 'Object > Envelope Distort > Edit Contents',
        placement: 'MenuBar',
        name: 'Edit Contents',
    },
    {
        id: 2164261212,
        label: 'Effect > Warp > Arc...',
        placement: 'MenuBar',
        name: 'Arc...',
    },
    {
        id: 2164261213,
        label: 'Effect > Warp > Arc Lower...',
        placement: 'MenuBar',
        name: 'Arc Lower...',
    },
    {
        id: 2164261214,
        label: 'Effect > Warp > Arc Upper...',
        placement: 'MenuBar',
        name: 'Arc Upper...',
    },
    {
        id: 2164261215,
        label: 'Effect > Warp > Arch...',
        placement: 'MenuBar',
        name: 'Arch...',
    },
    {
        id: 2164261216,
        label: 'Effect > Warp > Bulge...',
        placement: 'MenuBar',
        name: 'Bulge...',
    },
    {
        id: 2164261217,
        label: 'Effect > Warp > Shell Lower...',
        placement: 'MenuBar',
        name: 'Shell Lower...',
    },
    {
        id: 2164261218,
        label: 'Effect > Warp > Shell Upper...',
        placement: 'MenuBar',
        name: 'Shell Upper...',
    },
    {
        id: 2164261219,
        label: 'Effect > Warp > Flag...',
        placement: 'MenuBar',
        name: 'Flag...',
    },
    {
        id: 2164261220,
        label: 'Effect > Warp > Wave...',
        placement: 'MenuBar',
        name: 'Wave...',
    },
    {
        id: 2164261221,
        label: 'Effect > Warp > Fish...',
        placement: 'MenuBar',
        name: 'Fish...',
    },
    {
        id: 2164261222,
        label: 'Effect > Warp > Rise...',
        placement: 'MenuBar',
        name: 'Rise...',
    },
    {
        id: 2164261223,
        label: 'Effect > Warp > Fisheye...',
        placement: 'MenuBar',
        name: 'Fisheye...',
    },
    {
        id: 2164261224,
        label: 'Effect > Warp > Inflate...',
        placement: 'MenuBar',
        name: 'Inflate...',
    },
    {
        id: 2164261225,
        label: 'Effect > Warp > Squeeze...',
        placement: 'MenuBar',
        name: 'Squeeze...',
    },
    {
        id: 2164261226,
        label: 'Effect > Warp > Twist...',
        placement: 'MenuBar',
        name: 'Twist...',
    },
    {
        id: 2164261227,
        label: 'Object > Expand...',
        placement: 'MenuBar',
        name: 'Expand...',
    },
    {
        id: 2164261229,
        label: 'Edit > Spelling > Auto Spell Check',
        placement: 'MenuBar',
        name: 'Auto Spell Check',
    },
    {
        id: 2164261230,
        label: 'Edit > Spelling > Check Spelling...',
        placement: 'MenuBar',
        name: 'Check Spelling...',
    },
    {
        id: 2164261231,
        label: 'Select > Start Global Edit',
        placement: 'MenuBar',
        name: 'Start Global Edit',
    },
    {
        id: 2164261232,
        label: 'Illustrator > Settings… > Performance...',
        placement: 'MenuBar',
        name: 'Performance...',
    },
    {
        id: 2164261233,
        label: 'Illustrator > Settings… > File Handling...',
        placement: 'MenuBar',
        name: 'File Handling...',
    },
    {
        id: 2164261234,
        label: 'Illustrator > Settings… > Clipboard Handling...',
        placement: 'MenuBar',
        name: 'Clipboard Handling...',
    },
    {
        id: 2164261235,
        label: 'Illustrator > Settings… > Appearance of Black...',
        placement: 'MenuBar',
        name: 'Appearance of Black...',
    },
    {
        id: 2164261236,
        label: 'Illustrator > Settings… > Devices...',
        placement: 'MenuBar',
        name: 'Devices...',
    },
    {
        id: 2164261237,
        label: 'Window > Brushes',
        placement: 'MenuBar',
        name: 'Brushes',
    },
    {
        id: 2164261238,
        label: 'Select > Object > Brush Strokes',
        placement: 'MenuBar',
        name: 'Brush Strokes',
    },
    {
        id: 2164261241,
        label: 'Window > Brush Libraries > Arrows > Arrows_Special',
        placement: 'MenuBar',
        name: 'Arrows_Special',
    },
    {
        id: 2164261242,
        label: 'Window > Brush Libraries > Arrows > Arrows_Standard',
        placement: 'MenuBar',
        name: 'Arrows_Standard',
    },
    {
        id: 2164261243,
        label: 'Window > Brush Libraries > Arrows > Pattern Arrows',
        placement: 'MenuBar',
        name: 'Pattern Arrows',
    },
    {
        id: 2164261245,
        label: 'Window > Brush Libraries > Artistic > Artistic_Calligraphic',
        placement: 'MenuBar',
        name: 'Artistic_Calligraphic',
    },
    {
        id: 2164261246,
        label: 'Window > Brush Libraries > Artistic > Artistic_ChalkCharcoalPencil',
        placement: 'MenuBar',
        name: 'Artistic_ChalkCharcoalPencil',
    },
    {
        id: 2164261247,
        label: 'Window > Brush Libraries > Artistic > Artistic_Ink',
        placement: 'MenuBar',
        name: 'Artistic_Ink',
    },
    {
        id: 2164261248,
        label: 'Window > Brush Libraries > Artistic > Artistic_Paintbrush',
        placement: 'MenuBar',
        name: 'Artistic_Paintbrush',
    },
    {
        id: 2164261249,
        label: 'Window > Brush Libraries > Artistic > Artistic_ScrollPen',
        placement: 'MenuBar',
        name: 'Artistic_ScrollPen',
    },
    {
        id: 2164261250,
        label: 'Window > Brush Libraries > Artistic > Artistic_Watercolor',
        placement: 'MenuBar',
        name: 'Artistic_Watercolor',
    },
    {
        id: 2164261252,
        label: 'Window > Brush Libraries > Borders > Borders_Dashed',
        placement: 'MenuBar',
        name: 'Borders_Dashed',
    },
    {
        id: 2164261253,
        label: 'Window > Brush Libraries > Borders > Borders_Decorative',
        placement: 'MenuBar',
        name: 'Borders_Decorative',
    },
    {
        id: 2164261254,
        label: 'Window > Brush Libraries > Borders > Borders_Frames',
        placement: 'MenuBar',
        name: 'Borders_Frames',
    },
    {
        id: 2164261255,
        label: 'Window > Brush Libraries > Borders > Borders_Geometric',
        placement: 'MenuBar',
        name: 'Borders_Geometric',
    },
    {
        id: 2164261256,
        label: 'Window > Brush Libraries > Borders > Borders_Indigenous',
        placement: 'MenuBar',
        name: 'Borders_Indigenous',
    },
    {
        id: 2164261257,
        label: 'Window > Brush Libraries > Borders > Borders_Lines',
        placement: 'MenuBar',
        name: 'Borders_Lines',
    },
    {
        id: 2164261258,
        label: 'Window > Brush Libraries > Borders > Borders_Novelty',
        placement: 'MenuBar',
        name: 'Borders_Novelty',
    },
    {
        id: 2164261260,
        label: 'Window > Brush Libraries > Bristle Brush > Bristle Brush Library',
        placement: 'MenuBar',
        name: 'Bristle Brush Library',
    },
    {
        id: 2164261262,
        label: 'Window > Brush Libraries > Decorative > Decorative_Banners and Seals',
        placement: 'MenuBar',
        name: 'Decorative_Banners and Seals',
    },
    {
        id: 2164261263,
        label: 'Window > Brush Libraries > Decorative > Decorative_Scatter',
        placement: 'MenuBar',
        name: 'Decorative_Scatter',
    },
    {
        id: 2164261264,
        label: 'Window > Brush Libraries > Decorative > Decorative_Text Dividers',
        placement: 'MenuBar',
        name: 'Decorative_Text Dividers',
    },
    {
        id: 2164261265,
        label: 'Window > Brush Libraries > Decorative > Elegant Curl & Floral Brush Set',
        placement: 'MenuBar',
        name: 'Elegant Curl & Floral Brush Set',
    },
    {
        id: 2164261267,
        label: 'Window > Brush Libraries > Image Brush > Image Brush Library',
        placement: 'MenuBar',
        name: 'Image Brush Library',
    },
    {
        id: 2164261269,
        label: 'Window > Brush Libraries > Vector Packs > Grunge brushes vector pack',
        placement: 'MenuBar',
        name: 'Grunge brushes vector pack',
    },
    {
        id: 2164261270,
        label: 'Window > Brush Libraries > Vector Packs > Hand Drawn brushes vector pack',
        placement: 'MenuBar',
        name: 'Hand Drawn brushes vector pack',
    },
    {
        id: 2164261272,
        label: 'Window > Brush Libraries > Wacom 6D Brushes > 6d Art Pen Brushes',
        placement: 'MenuBar',
        name: '6d Art Pen Brushes',
    },
    {
        id: 2164261275,
        label: 'Window > Brush Libraries > Other Library...',
        placement: 'MenuBar',
        name: 'Other Library...',
    },
    {
        id: 2164261276,
        label: 'Window > Pathfinder',
        placement: 'MenuBar',
        name: 'Pathfinder',
    },
    {
        id: 2164261277,
        label: 'Edit > Find and Replace...',
        placement: 'MenuBar',
        name: 'Find and Replace...',
    },
    {
        id: 2164261278,
        label: 'Edit > Find Next',
        placement: 'MenuBar',
        name: 'Find Next',
    },
    {
        id: 2164261279,
        label: 'Effect > Rasterize...',
        placement: 'MenuBar',
        name: 'Rasterize...',
    },
    {
        id: 2164261281,
        label: 'Effect > Document Raster Effects Settings...',
        placement: 'MenuBar',
        name: 'Document Raster Effects Settings...',
    },
    {
        id: 2164261282,
        label: 'Object > Rasterize...',
        placement: 'MenuBar',
        name: 'Rasterize...',
    },
    {
        id: 2164261284,
        label: 'Object > Blend > Make',
        placement: 'MenuBar',
        name: 'Make',
    },
    {
        id: 2164261285,
        label: 'Object > Blend > Release',
        placement: 'MenuBar',
        name: 'Release',
    },
    {
        id: 2164261287,
        label: 'Object > Blend > Blend Options...',
        placement: 'MenuBar',
        name: 'Blend Options...',
    },
    {
        id: 2164261289,
        label: 'Object > Blend > Expand',
        placement: 'MenuBar',
        name: 'Expand',
    },
    {
        id: 2164261291,
        label: 'Object > Blend > Replace Spine',
        placement: 'MenuBar',
        name: 'Replace Spine',
    },
    {
        id: 2164261292,
        label: 'Object > Blend > Reverse Spine',
        placement: 'MenuBar',
        name: 'Reverse Spine',
    },
    {
        id: 2164261293,
        label: 'Object > Blend > Reverse Front to Back',
        placement: 'MenuBar',
        name: 'Reverse Front to Back',
    },
    {
        id: 2164261295,
        label: 'View > Show Slices',
        placement: 'MenuBar',
        name: 'Show Slices',
    },
    {
        id: 2164261296,
        label: 'View > Lock Slices',
        placement: 'MenuBar',
        name: 'Lock Slices',
    },
    {
        id: 2164261299,
        label: 'Object > Slice > Make',
        placement: 'MenuBar',
        name: 'Make',
    },
    {
        id: 2164261300,
        label: 'Object > Slice > Release',
        placement: 'MenuBar',
        name: 'Release',
    },
    {
        id: 2164261302,
        label: 'Object > Slice > Create from Guides',
        placement: 'MenuBar',
        name: 'Create from Guides',
    },
    {
        id: 2164261303,
        label: 'Object > Slice > Create from Selection',
        placement: 'MenuBar',
        name: 'Create from Selection',
    },
    {
        id: 2164261305,
        label: 'Object > Slice > Duplicate Slice',
        placement: 'MenuBar',
        name: 'Duplicate Slice',
    },
    {
        id: 2164261306,
        label: 'Object > Slice > Combine Slices',
        placement: 'MenuBar',
        name: 'Combine Slices',
    },
    {
        id: 2164261307,
        label: 'Object > Slice > Divide Slices...',
        placement: 'MenuBar',
        name: 'Divide Slices...',
    },
    {
        id: 2164261308,
        label: 'Object > Slice > Delete All',
        placement: 'MenuBar',
        name: 'Delete All',
    },
    {
        id: 2164261310,
        label: 'Object > Slice > Slice Options...',
        placement: 'MenuBar',
        name: 'Slice Options...',
    },
    {
        id: 2164261312,
        label: 'Object > Slice > Clip to Artboard',
        placement: 'MenuBar',
        name: 'Clip to Artboard',
    },
    {
        id: 2164261313,
        label: 'Window > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 2164261314,
        label: 'File > Save Selected Slices...',
        placement: 'MenuBar',
        name: 'Save Selected Slices...',
    },
    {
        id: 2164261316,
        label: 'Effect > SVG Filters > Apply SVG Filter...',
        placement: 'MenuBar',
        name: 'Apply SVG Filter...',
    },
    {
        id: 2164261317,
        label: 'Effect > SVG Filters > Import SVG Filter...',
        placement: 'MenuBar',
        name: 'Import SVG Filter...',
    },
    {
        id: 2164261319,
        label: 'Effect > Stylize > Feather...',
        placement: 'MenuBar',
        name: 'Feather...',
    },
    {
        id: 2164261321,
        label: 'Effect > 3D and Materials > Extrude & Bevel...',
        placement: 'MenuBar',
        name: 'Extrude & Bevel...',
    },
    {
        id: 2164261322,
        label: 'Effect > 3D and Materials > Revolve...',
        placement: 'MenuBar',
        name: 'Revolve...',
    },
    {
        id: 2164261323,
        label: 'Effect > 3D and Materials > Inflate...',
        placement: 'MenuBar',
        name: 'Inflate...',
    },
    {
        id: 2164261324,
        label: 'Effect > 3D and Materials > Rotate...',
        placement: 'MenuBar',
        name: 'Rotate...',
    },
    {
        id: 2164261325,
        label: 'Effect > 3D and Materials > Materials...',
        placement: 'MenuBar',
        name: 'Materials...',
    },
    {
        id: 2164261327,
        label: 'Effect > 3D and Materials > 3D (Classic) > Extrude & Bevel (Classic)...',
        placement: 'MenuBar',
        name: 'Extrude & Bevel (Classic)...',
    },
    {
        id: 2164261328,
        label: 'Effect > 3D and Materials > 3D (Classic) > Revolve (Classic)...',
        placement: 'MenuBar',
        name: 'Revolve (Classic)...',
    },
    {
        id: 2164261329,
        label: 'Effect > 3D and Materials > 3D (Classic) > Rotate (Classic)...',
        placement: 'MenuBar',
        name: 'Rotate (Classic)...',
    },
    {
        id: 2164261330,
        label: 'Window > SVG Interactivity',
        placement: 'MenuBar',
        name: 'SVG Interactivity',
    },
    {
        id: 2164261331,
        label: 'Object > Crop Image',
        placement: 'MenuBar',
        name: 'Crop Image',
    },
    {
        id: 2164261332,
        label: 'Window > Variables',
        placement: 'MenuBar',
        name: 'Variables',
    },
    {
        id: 2164261334,
        label: 'Window > Magic Wand',
        placement: 'MenuBar',
        name: 'Magic Wand',
    },
    {
        id: 2164261335,
        label: 'Object > Path > Divide Objects Below',
        placement: 'MenuBar',
        name: 'Divide Objects Below',
    },
    {
        id: 2164261336,
        label: 'Select > Object > Bristle Brush Strokes',
        placement: 'MenuBar',
        name: 'Bristle Brush Strokes',
    },
    {
        id: 2164261338,
        label: 'Object > Transform > Reset Bounding Box',
        placement: 'MenuBar',
        name: 'Reset Bounding Box',
    },
    {
        id: 2164261339,
        label: 'View > Hide Bounding Box',
        placement: 'MenuBar',
        name: 'Hide Bounding Box',
    },
    {
        id: 2164261340,
        label: 'Object > Arrange > Send to Current Layer',
        placement: 'MenuBar',
        name: 'Send to Current Layer',
    },
    {
        id: 2164261342,
        label: 'Object > Lock > All Artwork Above',
        placement: 'MenuBar',
        name: 'All Artwork Above',
    },
    {
        id: 2164261343,
        label: 'Object > Lock > Other Layers',
        placement: 'MenuBar',
        name: 'Other Layers',
    },
    {
        id: 2164261344,
        label: 'Object > Hide > All Artwork Above',
        placement: 'MenuBar',
        name: 'All Artwork Above',
    },
    {
        id: 2164261345,
        label: 'Object > Hide > Other Layers',
        placement: 'MenuBar',
        name: 'Other Layers',
    },
    {
        id: 2164261346,
        label: 'Select > Object > All on Same Layers',
        placement: 'MenuBar',
        name: 'All on Same Layers',
    },
    {
        id: 2164261347,
        label: 'Select > Object > Direction Handles',
        placement: 'MenuBar',
        name: 'Direction Handles',
    },
    {
        id: 2164261350,
        label: 'Select > Next Object Above',
        placement: 'MenuBar',
        name: 'Next Object Above',
    },
    {
        id: 2164261351,
        label: 'Select > Next Object Below',
        placement: 'MenuBar',
        name: 'Next Object Below',
    },
    {
        id: 2164261354,
        label: 'Select > Save Selection...',
        placement: 'MenuBar',
        name: 'Save Selection...',
    },
    {
        id: 2164261355,
        label: 'Select > Edit Selection...',
        placement: 'MenuBar',
        name: 'Edit Selection...',
    },
    {
        id: 2164261356,
        label: 'Select > Update Selection',
        placement: 'MenuBar',
        name: 'Update Selection',
    },
    {
        id: 2164261357,
        label: 'Object > Path > Simplify...',
        placement: 'MenuBar',
        name: 'Simplify...',
    },
    {
        id: 2164261358,
        label: 'Object > Path > Smooth...',
        placement: 'MenuBar',
        name: 'Smooth...',
    },
    {
        id: 2164261360,
        label: 'Object > Mockup > Preview Mockup',
        placement: 'MenuBar',
        name: 'Preview Mockup',
    },
    {
        id: 2164261361,
        label: 'Object > Mockup > Release',
        placement: 'MenuBar',
        name: 'Release',
    },
    {
        id: 2164261362,
        label: 'Object > Mockup > Edit',
        placement: 'MenuBar',
        name: 'Edit',
    },
    {
        id: 2164261363,
        label: 'Effect > Distort & Transform > Twist...',
        placement: 'MenuBar',
        name: 'Twist...',
    },
    {
        id: 2164261367,
        label: 'File > Scripts > Other Script...',
        placement: 'MenuBar',
        name: 'Other Script...',
    },
    {
        id: 2164261368,
        label: 'Window > CSS Properties (Deprecated)',
        placement: 'MenuBar',
        name: 'CSS Properties (Deprecated)',
    },
    {
        id: 2164261370,
        label: 'Effect > Path > Outline Object',
        placement: 'MenuBar',
        name: 'Outline Object',
    },
    {
        id: 2164261371,
        label: 'Window > Color',
        placement: 'MenuBar',
        name: 'Color',
    },
    {
        id: 2164261373,
        label: 'Window > Gradient',
        placement: 'MenuBar',
        name: 'Gradient',
    },
    {
        id: 2164261374,
        label: 'Window > Stroke',
        placement: 'MenuBar',
        name: 'Stroke',
    },
    {
        id: 2164261375,
        label: 'View > Hide Gradient Annotator',
        placement: 'MenuBar',
        name: 'Hide Gradient Annotator',
    },
    {
        id: 2164261376,
        label: 'Object > Path > Reverse Path Direction',
        placement: 'MenuBar',
        name: 'Reverse Path Direction',
    },
    {
        id: 2164261377,
        label: 'Window > Transparency',
        placement: 'MenuBar',
        name: 'Transparency',
    },
    {
        id: 2164261378,
        label: 'View > Show Transparency Grid',
        placement: 'MenuBar',
        name: 'Show Transparency Grid',
    },
    {
        id: 2164261379,
        label: 'Window > Swatches',
        placement: 'MenuBar',
        name: 'Swatches',
    },
    {
        id: 2164261382,
        label: 'Window > Pattern Options',
        placement: 'MenuBar',
        name: 'Pattern Options',
    },
    {
        id: 2164261383,
        label: 'Window > Generate Patterns (Beta)',
        placement: 'MenuBar',
        name: 'Generate Patterns (Beta)',
    },
    {
        id: 2164261385,
        label: 'Object > Pattern > Make',
        placement: 'MenuBar',
        name: 'Make',
    },
    {
        id: 2164261387,
        label: 'Object > Pattern > Edit Pattern',
        placement: 'MenuBar',
        name: 'Edit Pattern',
    },
    {
        id: 2164261388,
        label: 'Object > Pattern > Tile Edge Color...',
        placement: 'MenuBar',
        name: 'Tile Edge Color...',
    },
    {
        id: 2164261390,
        label: 'Object > Pattern > Generate Patterns (Beta)',
        placement: 'MenuBar',
        name: 'Generate Patterns (Beta)',
    },
    {
        id: 2164261392,
        label: 'Window > Swatch Libraries > Art History > Ancient',
        placement: 'MenuBar',
        name: 'Ancient',
    },
    {
        id: 2164261393,
        label: 'Window > Swatch Libraries > Art History > Baroque',
        placement: 'MenuBar',
        name: 'Baroque',
    },
    {
        id: 2164261394,
        label: 'Window > Swatch Libraries > Art History > Impressionism',
        placement: 'MenuBar',
        name: 'Impressionism',
    },
    {
        id: 2164261395,
        label: 'Window > Swatch Libraries > Art History > Middle Ages',
        placement: 'MenuBar',
        name: 'Middle Ages',
    },
    {
        id: 2164261396,
        label: 'Window > Swatch Libraries > Art History > Pop Art',
        placement: 'MenuBar',
        name: 'Pop Art',
    },
    {
        id: 2164261397,
        label: 'Window > Swatch Libraries > Art History > Prehistoric',
        placement: 'MenuBar',
        name: 'Prehistoric',
    },
    {
        id: 2164261398,
        label: 'Window > Swatch Libraries > Art History > Renaissance',
        placement: 'MenuBar',
        name: 'Renaissance',
    },
    {
        id: 2164261399,
        label: 'Window > Swatch Libraries > Art History > Russian Poster Art',
        placement: 'MenuBar',
        name: 'Russian Poster Art',
    },
    {
        id: 2164261400,
        label: 'Window > Swatch Libraries > Celebration',
        placement: 'MenuBar',
        name: 'Celebration',
    },
    {
        id: 2164261402,
        label: 'Window > Swatch Libraries > Color Books > ANPA Color',
        placement: 'MenuBar',
        name: 'ANPA Color',
    },
    {
        id: 2164261403,
        label: 'Window > Swatch Libraries > Color Books > DIC Color Guide',
        placement: 'MenuBar',
        name: 'DIC Color Guide',
    },
    {
        id: 2164261404,
        label: 'Window > Swatch Libraries > Color Books > FOCOLTONE',
        placement: 'MenuBar',
        name: 'FOCOLTONE',
    },
    {
        id: 2164261405,
        label: 'Window > Swatch Libraries > Color Books > HKS E Process',
        placement: 'MenuBar',
        name: 'HKS E Process',
    },
    {
        id: 2164261406,
        label: 'Window > Swatch Libraries > Color Books > HKS E',
        placement: 'MenuBar',
        name: 'HKS E',
    },
    {
        id: 2164261407,
        label: 'Window > Swatch Libraries > Color Books > HKS K Process',
        placement: 'MenuBar',
        name: 'HKS K Process',
    },
    {
        id: 2164261408,
        label: 'Window > Swatch Libraries > Color Books > HKS K',
        placement: 'MenuBar',
        name: 'HKS K',
    },
    {
        id: 2164261409,
        label: 'Window > Swatch Libraries > Color Books > HKS N Process',
        placement: 'MenuBar',
        name: 'HKS N Process',
    },
    {
        id: 2164261410,
        label: 'Window > Swatch Libraries > Color Books > HKS N',
        placement: 'MenuBar',
        name: 'HKS N',
    },
    {
        id: 2164261411,
        label: 'Window > Swatch Libraries > Color Books > HKS Z Process',
        placement: 'MenuBar',
        name: 'HKS Z Process',
    },
    {
        id: 2164261412,
        label: 'Window > Swatch Libraries > Color Books > HKS Z',
        placement: 'MenuBar',
        name: 'HKS Z',
    },
    {
        id: 2164261413,
        label: 'Window > Swatch Libraries > Color Books > TOYO 94 COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO 94 COLOR FINDER',
    },
    {
        id: 2164261414,
        label: 'Window > Swatch Libraries > Color Books > TOYO COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO COLOR FINDER',
    },
    {
        id: 2164261415,
        label: 'Window > Swatch Libraries > Color Books > TRUMATCH',
        placement: 'MenuBar',
        name: 'TRUMATCH',
    },
    {
        id: 2164261417,
        label: 'Window > Swatch Libraries > Color Properties > Bright',
        placement: 'MenuBar',
        name: 'Bright',
    },
    {
        id: 2164261418,
        label: 'Window > Swatch Libraries > Color Properties > Cool',
        placement: 'MenuBar',
        name: 'Cool',
    },
    {
        id: 2164261419,
        label: 'Window > Swatch Libraries > Color Properties > Dark',
        placement: 'MenuBar',
        name: 'Dark',
    },
    {
        id: 2164261420,
        label: 'Window > Swatch Libraries > Color Properties > Desaturated',
        placement: 'MenuBar',
        name: 'Desaturated',
    },
    {
        id: 2164261421,
        label: 'Window > Swatch Libraries > Color Properties > Light',
        placement: 'MenuBar',
        name: 'Light',
    },
    {
        id: 2164261422,
        label: 'Window > Swatch Libraries > Color Properties > Saturated',
        placement: 'MenuBar',
        name: 'Saturated',
    },
    {
        id: 2164261423,
        label: 'Window > Swatch Libraries > Color Properties > Soft',
        placement: 'MenuBar',
        name: 'Soft',
    },
    {
        id: 2164261424,
        label: 'Window > Swatch Libraries > Color Properties > Warm',
        placement: 'MenuBar',
        name: 'Warm',
    },
    {
        id: 2164261425,
        label: 'Window > Swatch Libraries > Corporate',
        placement: 'MenuBar',
        name: 'Corporate',
    },
    {
        id: 2164261427,
        label: 'Window > Swatch Libraries > Default Swatches > Art & Illustration',
        placement: 'MenuBar',
        name: 'Art & Illustration',
    },
    {
        id: 2164261428,
        label: 'Window > Swatch Libraries > Default Swatches > Mobile',
        placement: 'MenuBar',
        name: 'Mobile',
    },
    {
        id: 2164261429,
        label: 'Window > Swatch Libraries > Default Swatches > Print',
        placement: 'MenuBar',
        name: 'Print',
    },
    {
        id: 2164261430,
        label: 'Window > Swatch Libraries > Default Swatches > Video and Film',
        placement: 'MenuBar',
        name: 'Video and Film',
    },
    {
        id: 2164261431,
        label: 'Window > Swatch Libraries > Default Swatches > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261432,
        label: 'Window > Swatch Libraries > Earthtone',
        placement: 'MenuBar',
        name: 'Earthtone',
    },
    {
        id: 2164261434,
        label: 'Window > Swatch Libraries > Foods > Beverages',
        placement: 'MenuBar',
        name: 'Beverages',
    },
    {
        id: 2164261435,
        label: 'Window > Swatch Libraries > Foods > Fruit',
        placement: 'MenuBar',
        name: 'Fruit',
    },
    {
        id: 2164261436,
        label: 'Window > Swatch Libraries > Foods > Ice Cream',
        placement: 'MenuBar',
        name: 'Ice Cream',
    },
    {
        id: 2164261437,
        label: 'Window > Swatch Libraries > Foods > Sweets',
        placement: 'MenuBar',
        name: 'Sweets',
    },
    {
        id: 2164261438,
        label: 'Window > Swatch Libraries > Foods > Vegetables',
        placement: 'MenuBar',
        name: 'Vegetables',
    },
    {
        id: 2164261440,
        label: 'Window > Swatch Libraries > Gradients > Brights',
        placement: 'MenuBar',
        name: 'Brights',
    },
    {
        id: 2164261441,
        label: 'Window > Swatch Libraries > Gradients > Color Combinations',
        placement: 'MenuBar',
        name: 'Color Combinations',
    },
    {
        id: 2164261442,
        label: 'Window > Swatch Libraries > Gradients > Color Harmonies',
        placement: 'MenuBar',
        name: 'Color Harmonies',
    },
    {
        id: 2164261443,
        label: 'Window > Swatch Libraries > Gradients > Earthtones',
        placement: 'MenuBar',
        name: 'Earthtones',
    },
    {
        id: 2164261444,
        label: 'Window > Swatch Libraries > Gradients > Fades',
        placement: 'MenuBar',
        name: 'Fades',
    },
    {
        id: 2164261445,
        label: 'Window > Swatch Libraries > Gradients > Foliage',
        placement: 'MenuBar',
        name: 'Foliage',
    },
    {
        id: 2164261446,
        label: 'Window > Swatch Libraries > Gradients > Fruits and Vegetables',
        placement: 'MenuBar',
        name: 'Fruits and Vegetables',
    },
    {
        id: 2164261447,
        label: 'Window > Swatch Libraries > Gradients > Gems and Jewels',
        placement: 'MenuBar',
        name: 'Gems and Jewels',
    },
    {
        id: 2164261448,
        label: 'Window > Swatch Libraries > Gradients > Metals',
        placement: 'MenuBar',
        name: 'Metals',
    },
    {
        id: 2164261449,
        label: 'Window > Swatch Libraries > Gradients > Neutrals',
        placement: 'MenuBar',
        name: 'Neutrals',
    },
    {
        id: 2164261450,
        label: 'Window > Swatch Libraries > Gradients > Pastels',
        placement: 'MenuBar',
        name: 'Pastels',
    },
    {
        id: 2164261451,
        label: 'Window > Swatch Libraries > Gradients > Seasons',
        placement: 'MenuBar',
        name: 'Seasons',
    },
    {
        id: 2164261452,
        label: 'Window > Swatch Libraries > Gradients > Simple Radial',
        placement: 'MenuBar',
        name: 'Simple Radial',
    },
    {
        id: 2164261453,
        label: 'Window > Swatch Libraries > Gradients > Skintones',
        placement: 'MenuBar',
        name: 'Skintones',
    },
    {
        id: 2164261454,
        label: 'Window > Swatch Libraries > Gradients > Sky',
        placement: 'MenuBar',
        name: 'Sky',
    },
    {
        id: 2164261455,
        label: 'Window > Swatch Libraries > Gradients > Spectrums',
        placement: 'MenuBar',
        name: 'Spectrums',
    },
    {
        id: 2164261456,
        label: 'Window > Swatch Libraries > Gradients > Stone and Brick',
        placement: 'MenuBar',
        name: 'Stone and Brick',
    },
    {
        id: 2164261457,
        label: 'Window > Swatch Libraries > Gradients > Tints and Shades',
        placement: 'MenuBar',
        name: 'Tints and Shades',
    },
    {
        id: 2164261458,
        label: 'Window > Swatch Libraries > Gradients > Vignettes',
        placement: 'MenuBar',
        name: 'Vignettes',
    },
    {
        id: 2164261459,
        label: 'Window > Swatch Libraries > Gradients > Water',
        placement: 'MenuBar',
        name: 'Water',
    },
    {
        id: 2164261460,
        label: 'Window > Swatch Libraries > Gradients > Wood',
        placement: 'MenuBar',
        name: 'Wood',
    },
    {
        id: 2164261461,
        label: 'Window > Swatch Libraries > Kids Stuff',
        placement: 'MenuBar',
        name: 'Kids Stuff',
    },
    {
        id: 2164261462,
        label: 'Window > Swatch Libraries > Metal',
        placement: 'MenuBar',
        name: 'Metal',
    },
    {
        id: 2164261464,
        label: 'Window > Swatch Libraries > Nature > Beach',
        placement: 'MenuBar',
        name: 'Beach',
    },
    {
        id: 2164261465,
        label: 'Window > Swatch Libraries > Nature > Flowers',
        placement: 'MenuBar',
        name: 'Flowers',
    },
    {
        id: 2164261466,
        label: 'Window > Swatch Libraries > Nature > Foliage',
        placement: 'MenuBar',
        name: 'Foliage',
    },
    {
        id: 2164261467,
        label: 'Window > Swatch Libraries > Nature > Landscape',
        placement: 'MenuBar',
        name: 'Landscape',
    },
    {
        id: 2164261468,
        label: 'Window > Swatch Libraries > Nature > Seasons',
        placement: 'MenuBar',
        name: 'Seasons',
    },
    {
        id: 2164261469,
        label: 'Window > Swatch Libraries > Nature > Stone and Brick',
        placement: 'MenuBar',
        name: 'Stone and Brick',
    },
    {
        id: 2164261470,
        label: 'Window > Swatch Libraries > Neutral',
        placement: 'MenuBar',
        name: 'Neutral',
    },
    {
        id: 2164261473,
        label: 'Window > Swatch Libraries > Patterns > Basic Graphics > Basic Graphics_Dots',
        placement: 'MenuBar',
        name: 'Basic Graphics_Dots',
    },
    {
        id: 2164261474,
        label: 'Window > Swatch Libraries > Patterns > Basic Graphics > Basic Graphics_Lines',
        placement: 'MenuBar',
        name: 'Basic Graphics_Lines',
    },
    {
        id: 2164261475,
        label: 'Window > Swatch Libraries > Patterns > Basic Graphics > Basic Graphics_Textures',
        placement: 'MenuBar',
        name: 'Basic Graphics_Textures',
    },
    {
        id: 2164261477,
        label: 'Window > Swatch Libraries > Patterns > Decorative > Decorative Legacy',
        placement: 'MenuBar',
        name: 'Decorative Legacy',
    },
    {
        id: 2164261478,
        label: 'Window > Swatch Libraries > Patterns > Decorative > Vonster Patterns',
        placement: 'MenuBar',
        name: 'Vonster Patterns',
    },
    {
        id: 2164261480,
        label: 'Window > Swatch Libraries > Patterns > Nature > Nature_Animal Skins',
        placement: 'MenuBar',
        name: 'Nature_Animal Skins',
    },
    {
        id: 2164261481,
        label: 'Window > Swatch Libraries > Patterns > Nature > Nature_Foliage',
        placement: 'MenuBar',
        name: 'Nature_Foliage',
    },
    {
        id: 2164261483,
        label: 'Window > Swatch Libraries > Scientific > Analogous',
        placement: 'MenuBar',
        name: 'Analogous',
    },
    {
        id: 2164261484,
        label: 'Window > Swatch Libraries > Scientific > Complementary',
        placement: 'MenuBar',
        name: 'Complementary',
    },
    {
        id: 2164261485,
        label: 'Window > Swatch Libraries > Scientific > Split Complementary',
        placement: 'MenuBar',
        name: 'Split Complementary',
    },
    {
        id: 2164261486,
        label: 'Window > Swatch Libraries > Scientific > Tetrad',
        placement: 'MenuBar',
        name: 'Tetrad',
    },
    {
        id: 2164261487,
        label: 'Window > Swatch Libraries > Scientific > Triad',
        placement: 'MenuBar',
        name: 'Triad',
    },
    {
        id: 2164261488,
        label: 'Window > Swatch Libraries > Skintones',
        placement: 'MenuBar',
        name: 'Skintones',
    },
    {
        id: 2164261489,
        label: 'Window > Swatch Libraries > System (Macintosh)',
        placement: 'MenuBar',
        name: 'System (Macintosh)',
    },
    {
        id: 2164261490,
        label: 'Window > Swatch Libraries > System (Windows)',
        placement: 'MenuBar',
        name: 'System (Windows)',
    },
    {
        id: 2164261491,
        label: 'Window > Swatch Libraries > Textiles',
        placement: 'MenuBar',
        name: 'Textiles',
    },
    {
        id: 2164261492,
        label: 'Window > Swatch Libraries > VisiBone2',
        placement: 'MenuBar',
        name: 'VisiBone2',
    },
    {
        id: 2164261493,
        label: 'Window > Swatch Libraries > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261496,
        label: 'Window > Swatch Libraries > Other Library...',
        placement: 'MenuBar',
        name: 'Other Library...',
    },
    {
        id: 2164261497,
        label: 'Window > Color Guide',
        placement: 'MenuBar',
        name: 'Color Guide',
    },
    {
        id: 2164261498,
        label: 'Edit > Edit Colors > Recolor Artwork...',
        placement: 'MenuBar',
        name: 'Recolor Artwork...',
    },
    {
        id: 2164261501,
        label: 'Edit > Edit Colors > Generative Recolor',
        placement: 'MenuBar',
        name: 'Generative Recolor',
    },
    {
        id: 2164261503,
        label: 'Edit > Edit Colors > Recolor with Preset > Color library...',
        placement: 'MenuBar',
        name: 'Color library...',
    },
    {
        id: 2164261504,
        label: 'Edit > Edit Colors > Recolor with Preset > Single Color',
        placement: 'MenuBar',
        name: 'Single Color',
    },
    {
        id: 2164261505,
        label: 'Edit > Edit Colors > Recolor with Preset > Two Color',
        placement: 'MenuBar',
        name: 'Two Color',
    },
    {
        id: 2164261506,
        label: 'Edit > Edit Colors > Recolor with Preset > Three Color',
        placement: 'MenuBar',
        name: 'Three Color',
    },
    {
        id: 2164261507,
        label: 'Edit > Edit Colors > Recolor with Preset > Color Harmony',
        placement: 'MenuBar',
        name: 'Color Harmony',
    },
    {
        id: 2164261508,
        label: 'Window > Control',
        placement: 'MenuBar',
        name: 'Control',
    },
    {
        id: 2164261509,
        label: 'Window > Contextual Task Bar',
        placement: 'MenuBar',
        name: 'Contextual Task Bar',
    },
    {
        id: 2164261511,
        label: 'Object > Intertwine > Make',
        placement: 'MenuBar',
        name: 'Make',
    },
    {
        id: 2164261512,
        label: 'Object > Intertwine > Release',
        placement: 'MenuBar',
        name: 'Release',
    },
    {
        id: 2164261513,
        label: 'Object > Intertwine > Edit',
        placement: 'MenuBar',
        name: 'Edit',
    },
    {
        id: 2164261514,
        label: 'Window > Align',
        placement: 'MenuBar',
        name: 'Align',
    },
    {
        id: 2164261516,
        label: 'Object > Align > Horizontal Align Left',
        placement: 'MenuBar',
        name: 'Horizontal Align Left',
    },
    {
        id: 2164261517,
        label: 'Object > Align > Horizontal Align Center',
        placement: 'MenuBar',
        name: 'Horizontal Align Center',
    },
    {
        id: 2164261518,
        label: 'Object > Align > Horizontal Align Right',
        placement: 'MenuBar',
        name: 'Horizontal Align Right',
    },
    {
        id: 2164261519,
        label: 'Object > Align > Vertical Align Top',
        placement: 'MenuBar',
        name: 'Vertical Align Top',
    },
    {
        id: 2164261520,
        label: 'Object > Align > Vertical Align Center',
        placement: 'MenuBar',
        name: 'Vertical Align Center',
    },
    {
        id: 2164261521,
        label: 'Object > Align > Vertical Align Bottom',
        placement: 'MenuBar',
        name: 'Vertical Align Bottom',
    },
    {
        id: 2164261523,
        label: 'Object > Distribute > Vertical Distribute Top',
        placement: 'MenuBar',
        name: 'Vertical Distribute Top',
    },
    {
        id: 2164261524,
        label: 'Object > Distribute > Vertical Distribute Center',
        placement: 'MenuBar',
        name: 'Vertical Distribute Center',
    },
    {
        id: 2164261525,
        label: 'Object > Distribute > Vertical Distribute Bottom',
        placement: 'MenuBar',
        name: 'Vertical Distribute Bottom',
    },
    {
        id: 2164261526,
        label: 'Object > Distribute > Horizontal Distribute Left',
        placement: 'MenuBar',
        name: 'Horizontal Distribute Left',
    },
    {
        id: 2164261527,
        label: 'Object > Distribute > Horizontal Distribute Center',
        placement: 'MenuBar',
        name: 'Horizontal Distribute Center',
    },
    {
        id: 2164261528,
        label: 'Object > Distribute > Horizontal Distribute Right',
        placement: 'MenuBar',
        name: 'Horizontal Distribute Right',
    },
    {
        id: 2164261529,
        label: 'Window > Transform',
        placement: 'MenuBar',
        name: 'Transform',
    },
    {
        id: 2164261530,
        label: 'View > Hide Corner Widget',
        placement: 'MenuBar',
        name: 'Hide Corner Widget',
    },
    {
        id: 2164261532,
        label: 'Object > Repeat > Radial',
        placement: 'MenuBar',
        name: 'Radial',
    },
    {
        id: 2164261533,
        label: 'Object > Repeat > Grid',
        placement: 'MenuBar',
        name: 'Grid',
    },
    {
        id: 2164261534,
        label: 'Object > Repeat > Mirror',
        placement: 'MenuBar',
        name: 'Mirror',
    },
    {
        id: 2164261536,
        label: 'Object > Repeat > Release',
        placement: 'MenuBar',
        name: 'Release',
    },
    {
        id: 2164261537,
        label: 'Object > Repeat > Options...',
        placement: 'MenuBar',
        name: 'Options...',
    },
    {
        id: 2164261539,
        label: 'Object > Objects on Path > Attach...',
        placement: 'MenuBar',
        name: 'Attach...',
    },
    {
        id: 2164261540,
        label: 'Object > Objects on Path > Options...',
        placement: 'MenuBar',
        name: 'Options...',
    },
    {
        id: 2164261541,
        label: 'Object > Objects on Path > Expand',
        placement: 'MenuBar',
        name: 'Expand',
    },
    {
        id: 2164261542,
        label: 'Effect > Path > Outline Stroke',
        placement: 'MenuBar',
        name: 'Outline Stroke',
    },
    {
        id: 2164261543,
        label: 'Effect > Path > Offset Path...',
        placement: 'MenuBar',
        name: 'Offset Path...',
    },
    {
        id: 2164261544,
        label: 'Object > Path > Outline Stroke',
        placement: 'MenuBar',
        name: 'Outline Stroke',
    },
    {
        id: 2164261545,
        label: 'Object > Path > Offset Path...',
        placement: 'MenuBar',
        name: 'Offset Path...',
    },
    {
        id: 2164261547,
        label: 'Window > Toolbars > Basic',
        placement: 'MenuBar',
        name: 'Basic',
    },
    {
        id: 2164261548,
        label: 'Window > Toolbars > Advanced',
        placement: 'MenuBar',
        name: 'Advanced',
    },
    {
        id: 2164261549,
        label: 'Window > Toolbars > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261551,
        label: 'Window > Toolbars > New Toolbar...',
        placement: 'MenuBar',
        name: 'New Toolbar...',
    },
    {
        id: 2164261552,
        label: 'Window > Toolbars > Manage Toolbars...',
        placement: 'MenuBar',
        name: 'Manage Toolbars...',
    },
    {
        id: 2164261553,
        label: 'Window > Attributes',
        placement: 'MenuBar',
        name: 'Attributes',
    },
    {
        id: 2164261554,
        label: 'Type > More from Adobe Fonts...',
        placement: 'MenuBar',
        name: 'More from Adobe Fonts...',
    },
    {
        id: 2164261555,
        label: 'Type > Resolve Missing Fonts...',
        placement: 'MenuBar',
        name: 'Resolve Missing Fonts...',
    },
    {
        id: 2164261556,
        label: 'Help > Support Community',
        placement: 'MenuBar',
        name: 'Support Community',
    },
    {
        id: 2164261557,
        label: 'Help > Submit Bug/Feature Request...',
        placement: 'MenuBar',
        name: 'Submit Bug/Feature Request...',
    },
    {
        id: 2164261559,
        label: 'Object > Make Pixel Perfect',
        placement: 'MenuBar',
        name: 'Make Pixel Perfect',
    },
    {
        id: 2164261560,
        label: 'Window > Type > Reflow Viewer',
        placement: 'MenuBar',
        name: 'Reflow Viewer',
    },
    {
        id: 2164261561,
        label: 'Help > Generative AI User Guidelines',
        placement: 'MenuBar',
        name: 'Generative AI User Guidelines',
    },
    {
        id: 2164261563,
        label: 'Edit > Print Presets...',
        placement: 'MenuBar',
        name: 'Print Presets...',
    },
    {
        id: 2164261565,
        label: 'File > Print...',
        placement: 'MenuBar',
        name: 'Print...',
    },
    {
        id: 2164261566,
        label: 'Edit > Transparency Flattener Presets...',
        placement: 'MenuBar',
        name: 'Transparency Flattener Presets...',
    },
    {
        id: 2164261567,
        label: 'Object > Flatten Transparency...',
        placement: 'MenuBar',
        name: 'Flatten Transparency...',
    },
    {
        id: 2164261569,
        label: 'Object > Shape > Convert to Shape',
        placement: 'MenuBar',
        name: 'Convert to Shape',
    },
    {
        id: 2164261570,
        label: 'Object > Shape > Expand Shape',
        placement: 'MenuBar',
        name: 'Expand Shape',
    },
    {
        id: 2164261571,
        label: 'Window > Mockup',
        placement: 'MenuBar',
        name: 'Mockup',
    },
    {
        id: 2164261572,
        label: 'Window > Generated Variations',
        placement: 'MenuBar',
        name: 'Generated Variations',
    },
    {
        id: 2164261573,
        label: 'Object > Generate Vectors (Beta)...',
        placement: 'MenuBar',
        name: 'Generate Vectors (Beta)...',
    },
    {
        id: 2164261574,
        label: 'File > Generate Vectors (Beta)...',
        placement: 'MenuBar',
        name: 'Generate Vectors (Beta)...',
    },
    {
        id: 2164261575,
        label: 'Object > Gen Shape Fill (Beta)...',
        placement: 'MenuBar',
        name: 'Gen Shape Fill (Beta)...',
    },
    {
        id: 2164261576,
        label: 'Window > 3D and Materials',
        placement: 'MenuBar',
        name: '3D and Materials',
    },
    {
        id: 2164261578,
        label: 'Object > Perspective > Attach to Active Plane',
        placement: 'MenuBar',
        name: 'Attach to Active Plane',
    },
    {
        id: 2164261579,
        label: 'Object > Perspective > Release with Perspective',
        placement: 'MenuBar',
        name: 'Release with Perspective',
    },
    {
        id: 2164261580,
        label: 'Object > Perspective > Move Plane to Match Object',
        placement: 'MenuBar',
        name: 'Move Plane to Match Object',
    },
    {
        id: 2164261581,
        label: 'Object > Perspective > Edit Text',
        placement: 'MenuBar',
        name: 'Edit Text',
    },
    {
        id: 2164261582,
        label: 'Edit > Perspective Grid Presets...',
        placement: 'MenuBar',
        name: 'Perspective Grid Presets...',
    },
    {
        id: 2164261585,
        label: 'View > Perspective Grid > Show Grid',
        placement: 'MenuBar',
        name: 'Show Grid',
    },
    {
        id: 2164261586,
        label: 'View > Perspective Grid > Show Rulers',
        placement: 'MenuBar',
        name: 'Show Rulers',
    },
    {
        id: 2164261587,
        label: 'View > Perspective Grid > Snap to Grid',
        placement: 'MenuBar',
        name: 'Snap to Grid',
    },
    {
        id: 2164261588,
        label: 'View > Perspective Grid > Lock Grid',
        placement: 'MenuBar',
        name: 'Lock Grid',
    },
    {
        id: 2164261589,
        label: 'View > Perspective Grid > Lock Station Point',
        placement: 'MenuBar',
        name: 'Lock Station Point',
    },
    {
        id: 2164261591,
        label: 'View > Perspective Grid > Define Grid...',
        placement: 'MenuBar',
        name: 'Define Grid...',
    },
    {
        id: 2164261597,
        label: 'View > Perspective Grid > Save Grid as Preset...',
        placement: 'MenuBar',
        name: 'Save Grid as Preset...',
    },
    {
        id: 2164261598,
        label: 'Window > Image Trace',
        placement: 'MenuBar',
        name: 'Image Trace',
    },
    {
        id: 2164261600,
        label: 'Object > Image Trace > Make',
        placement: 'MenuBar',
        name: 'Make',
    },
    {
        id: 2164261601,
        label: 'Object > Image Trace > Make and Expand',
        placement: 'MenuBar',
        name: 'Make and Expand',
    },
    {
        id: 2164261602,
        label: 'Object > Image Trace > Release',
        placement: 'MenuBar',
        name: 'Release',
    },
    {
        id: 2164261604,
        label: 'Object > Image Trace > Expand',
        placement: 'MenuBar',
        name: 'Expand',
    },
    {
        id: 2164261605,
        label: 'Effect > Blur > Gaussian Blur...',
        placement: 'MenuBar',
        name: 'Gaussian Blur...',
    },
    {
        id: 2164261606,
        label: 'Edit > Adobe PDF Presets...',
        placement: 'MenuBar',
        name: 'Adobe PDF Presets...',
    },
    {
        id: 2164261607,
        label: 'Window > Asset Export',
        placement: 'MenuBar',
        name: 'Asset Export',
    },
    {
        id: 2164261608,
        label: 'File > Invite to Edit...',
        placement: 'MenuBar',
        name: 'Invite to Edit...',
    },
    {
        id: 2164261609,
        label: 'File > Share for Review...',
        placement: 'MenuBar',
        name: 'Share for Review...',
    },
    {
        id: 2164261610,
        label: 'View > Perspective Grid > One Point Perspective > [1P-Normal View]',
        placement: 'MenuBar',
        name: '[1P-Normal View]',
    },
    {
        id: 2164261611,
        label: 'View > Perspective Grid > Two Point Perspective > [2P-Normal View]',
        placement: 'MenuBar',
        name: '[2P-Normal View]',
    },
    {
        id: 2164261612,
        label: 'View > Perspective Grid > Three Point Perspective > [3P-Normal View]',
        placement: 'MenuBar',
        name: '[3P-Normal View]',
    },
    {
        id: 2164261615,
        label: 'Window > Extensions > Libraries',
        placement: 'MenuBar',
        name: 'Libraries',
    },
    {
        id: 2164261616,
        label: 'Window > Version History',
        placement: 'MenuBar',
        name: 'Version History',
    },
    {
        id: 2164261617,
        label: 'File > Version History',
        placement: 'MenuBar',
        name: 'Version History',
    },
    {
        id: 2164261618,
        label: 'Window > Comments',
        placement: 'MenuBar',
        name: 'Comments',
    },
    {
        id: 'Adobe Scroll Tool',
        label: 'Hand Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pen Tool',
        label: 'Pen Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scale Tool',
        label: 'Scale Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Tool',
        label: 'Rotate Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reflect Tool',
        label: 'Reflect Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shear Tool',
        label: 'Shear Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scissors Tool',
        label: 'Scissors Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Measure Tool',
        label: 'Measure Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Page Tool',
        label: 'Print Tiling Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Object Select Tool',
        label: 'Group Selection Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Select Tool',
        label: 'Direct Selection Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Select Tool',
        label: 'Selection Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Zoom Tool',
        label: 'Zoom Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Add Anchor Point Tool',
        label: 'Add Anchor Point Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Delete Anchor Point Tool',
        label: 'Delete Anchor Point Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Anchor Point Tool',
        label: 'Anchor Point Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Column Graph Tool',
        label: 'Column Graph Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Column Graph Tool',
        label: 'Stacked Column Graph Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Graph Tool',
        label: 'Line Graph Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pie Graph Tool',
        label: 'Pie Graph Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Graph Tool',
        label: 'Area Graph Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scatter Graph Tool',
        label: 'Scatter Graph Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bar Graph Tool',
        label: 'Bar Graph Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Bar Graph Tool',
        label: 'Stacked Bar Graph Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Radar Graph Tool',
        label: 'Radar Graph Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Mesh Editing Tool',
        label: 'Mesh Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Type Tool',
        label: 'Type Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Type Tool',
        label: 'Area Type Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Path Type Tool',
        label: 'Type on a Path Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Type Tool',
        label: 'Vertical Type Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Area Type Tool',
        label: 'Vertical Area Type Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Path Type Tool',
        label: 'Vertical Type on a Path Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Touch Type Tool',
        label: 'Touch Type Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Builder Tool',
        label: 'Shape Builder Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Paintbucket Tool',
        label: 'Live Paint Bucket',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Face Select Tool',
        label: 'Live Paint Selection Tool',
        placement: 'Tool',
    },
    {
        id: 'Perspective Grid Tool',
        label: 'Perspective Grid Tool',
        placement: 'Tool',
    },
    {
        id: 'Perspective Selection Tool',
        label: 'Perspective Selection Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blend Tool',
        label: 'Blend Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Tool',
        label: 'Slice Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Select Tool',
        label: 'Slice Selection Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Lasso Tool',
        label: 'Lasso Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Crop Tool',
        label: 'Artboard Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Curvature Tool',
        label: 'Curvature Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shaper Tool',
        label: 'Shaper Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Puppet Warp Tool',
        label: 'Puppet Warp Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Magic Wand Tool',
        label: 'Magic Wand Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Knife Tool',
        label: 'Knife Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Flare Tool',
        label: 'Flare Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Free Transform Tool',
        label: 'Free Transform Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Tool',
        label: 'Line Segment Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Arc Tool',
        label: 'Arc Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangular Grid Tool',
        label: 'Rectangular Grid Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Polar Grid Tool',
        label: 'Polar Grid Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Warp Tool',
        label: 'Warp Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe New Twirl Tool',
        label: 'Twirl Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pucker Tool',
        label: 'Pucker Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bloat Tool',
        label: 'Bloat Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scallop Tool',
        label: 'Scallop Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Cyrstallize Tool',
        label: 'Crystallize Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Wrinkle Tool',
        label: 'Wrinkle Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Quick Pen Tool',
        label: 'Quick Pen Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Tool',
        label: 'Pencil Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Brush Tool',
        label: 'Paintbrush Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blob Brush Tool',
        label: 'Blob Brush Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Smooth Tool',
        label: 'Smooth Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Erase Tool',
        label: 'Path Eraser Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Corner Join Tool',
        label: 'Join Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Ellipse Shape Tool',
        label: 'Ellipse Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Regular Polygon Tool',
        label: 'Polygon Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Star Tool',
        label: 'Star Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangle Shape Tool',
        label: 'Rectangle Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rounded Rectangle Tool',
        label: 'Rounded Rectangle Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Spiral Tool',
        label: 'Spiral Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sprayer Tool',
        label: 'Symbol Sprayer Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Shifter Tool',
        label: 'Symbol Shifter Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Scruncher Tool',
        label: 'Symbol Scruncher Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sizer Tool',
        label: 'Symbol Sizer Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Spinner Tool',
        label: 'Symbol Spinner Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Stainer Tool',
        label: 'Symbol Stainer Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Screener Tool',
        label: 'Symbol Screener Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Styler Tool',
        label: 'Symbol Styler Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Gradient Vector Tool',
        label: 'Gradient Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Dimension Tool',
        label: 'Dimension Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Constraints Tool',
        label: 'Objects on Path',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Canvas Tool',
        label: 'Rotate View Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reshape Tool',
        label: 'Reshape Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Width Tool',
        label: 'Width Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eraser Tool',
        label: 'Eraser Tool',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eyedropper Tool',
        label: 'Eyedropper Tool',
        placement: 'Tool',
    },
    {
        id: '3D and Materials',
        label: '3D and Materials',
        placement: 'Panel',
    },
    {
        id: 'Actions',
        label: 'Actions',
        placement: 'Panel',
    },
    {
        id: 'AdobeAltGlyphsPanel',
        label: 'Glyphs',
        placement: 'Panel',
    },
    {
        id: 'AdobeBrush',
        label: 'Brushes',
        placement: 'Panel',
    },
    {
        id: 'AdobeCharStyles',
        label: 'Character Styles',
        placement: 'Panel',
    },
    {
        id: 'AdobeColorGuidePanel',
        label: 'Color Guide',
        placement: 'Panel',
    },
    {
        id: 'AdobeFlatteningPreview',
        label: 'Flattener Preview',
        placement: 'Panel',
    },
    {
        id: 'AdobeGradientEditor',
        label: 'Gradient',
        placement: 'Panel',
    },
    {
        id: 'AdobeHorizontalTabPanel',
        label: 'Tabs',
        placement: 'Panel',
    },
    {
        id: 'AdobeLayerPalette',
        label: 'Layers',
        placement: 'Panel',
    },
    {
        id: 'AdobeObjectAttributes',
        label: 'Attributes',
        placement: 'Panel',
    },
    {
        id: 'AdobeOpenTypeFont',
        label: 'OpenType',
        placement: 'Panel',
    },
    {
        id: 'AdobeParaStyles',
        label: 'Paragraph Styles',
        placement: 'Panel',
    },
    {
        id: 'AdobePropertiesPanel',
        label: 'Properties',
        placement: 'Panel',
    },
    {
        id: 'AdobeSeparationPreview',
        label: 'Separations Preview',
        placement: 'Panel',
    },
    {
        id: 'AdobeSwatch_',
        label: 'Swatches',
        placement: 'Panel',
    },
    {
        id: 'AdobeVariablesPanel',
        label: 'Variables',
        placement: 'Panel',
    },
    {
        id: 'AdobeVerticalTabPanel',
        label: 'Tabs',
        placement: 'Panel',
    },
    {
        id: 'Align',
        label: 'Align',
        placement: 'Panel',
    },
    {
        id: 'Appearance',
        label: 'Appearance',
        placement: 'Panel',
    },
    {
        id: 'Artboards',
        label: 'Artboards',
        placement: 'Panel',
    },
    {
        id: 'CCX Commenting UXP Webview',
        label: 'Comments',
        placement: 'Panel',
    },
    {
        id: 'CSS',
        label: 'CSS Properties (Deprecated)',
        placement: 'Panel',
    },
    {
        id: 'CSXSExtension_com.adobe.DesignLibraries.angular_0',
        label: 'Libraries',
        placement: 'Panel',
    },
    {
        id: 'Character',
        label: 'Character',
        placement: 'Panel',
    },
    {
        id: 'Color',
        label: 'Color',
        placement: 'Panel',
    },
    {
        id: 'Document Info',
        label: 'Document Info',
        placement: 'Panel',
    },
    {
        id: 'Export',
        label: 'Asset Export',
        placement: 'Panel',
    },
    {
        id: 'GeneratedVariations',
        label: 'Generated Variations',
        placement: 'Panel',
    },
    {
        id: 'History',
        label: 'History',
        placement: 'Panel',
    },
    {
        id: 'Info',
        label: 'Info',
        placement: 'Panel',
    },
    {
        id: 'Links',
        label: 'Links',
        placement: 'Panel',
    },
    {
        id: 'Magic Wand',
        label: 'Magic Wand',
        placement: 'Panel',
    },
    {
        id: 'Mockup',
        label: 'Mockup',
        placement: 'Panel',
    },
    {
        id: 'NamedStyle',
        label: 'Graphic Styles',
        placement: 'Panel',
    },
    {
        id: 'Navigator',
        label: 'Navigator',
        placement: 'Panel',
    },
    {
        id: 'Paragraph',
        label: 'Paragraph',
        placement: 'Panel',
    },
    {
        id: 'Pathfinder',
        label: 'Pathfinder',
        placement: 'Panel',
    },
    {
        id: 'PatternOptionsPanel',
        label: 'Pattern Options',
        placement: 'Panel',
    },
    {
        id: 'Reflow Viewer',
        label: 'Reflow Viewer',
        placement: 'Panel',
    },
    {
        id: 'Retype',
        label: 'Retype',
        placement: 'Panel',
    },
    {
        id: 'SVGInteractivity',
        label: 'SVG Interactivity',
        placement: 'Panel',
    },
    {
        id: 'Stroke',
        label: 'Stroke',
        placement: 'Panel',
    },
    {
        id: 'Symbols',
        label: 'Symbols',
        placement: 'Panel',
    },
    {
        id: 'Transform',
        label: 'Transform',
        placement: 'Panel',
    },
    {
        id: 'Transparency',
        label: 'Transparency',
        placement: 'Panel',
    },
    {
        id: 'Vectorize',
        label: 'Image Trace',
        placement: 'Panel',
    },
    {
        id: 'ccx-timeline',
        label: 'Version History',
        placement: 'Panel',
    },
];
